import { aX as _r, aY as Qn, aZ as yi, a_ as gi, a$ as bi, b0 as se, b1 as Jn, b2 as Vt, b3 as Mn, b4 as wi, b5 as ki, b6 as Sr, b7 as vi, aI as Ir, b8 as Nn, b9 as R, ba as G, bb as Ei, bc as ye, bd as V, be as z, aH as xi, bf as Ci, bg as Ae, bh as Or, bi as Ai, bj as Rn, bk as Tn, bl as _i, bm as Si, bn as Mr, bo as Nr, bp as Ii, bq as F, br as H, bs as Oi, bt as un, bu as pe, bv as Mi, bw as Ni, bx as pn, by as Zn, bz as Rr, bA as ae, bB as Ri, bC as Ti, bD as Pi, bE as Bi, bF as ji, bG as Di, bH as $i } from "./index-e2b4b6ed.js";
import { m as qn } from "./browser-ponyfill-357e1767.js";
import * as ln from "react";
import w, { createContext as Li, useState as Gt, useEffect as Tr, useCallback as zi, useContext as Fi } from "react";
import Ui from "react-dom";
function Yn(r, e, n, t, i, c, o) {
  try {
    var d = r[c](o), u = d.value;
  } catch (s) {
    n(s);
    return;
  }
  d.done ? e(u) : Promise.resolve(u).then(t, i);
}
function Bt(r) {
  return function() {
    var e = this, n = arguments;
    return new Promise(function(t, i) {
      var c = r.apply(e, n);
      function o(u) {
        Yn(c, t, i, o, d, "next", u);
      }
      function d(u) {
        Yn(c, t, i, o, d, "throw", u);
      }
      o(void 0);
    });
  };
}
function Vi(r, e) {
  if (!(r instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function Kn(r, e) {
  for (var n = 0; n < e.length; n++) {
    var t = e[n];
    t.enumerable = t.enumerable || !1, t.configurable = !0, "value" in t && (t.writable = !0), Object.defineProperty(r, t.key, t);
  }
}
function Hi(r, e, n) {
  return e && Kn(r.prototype, e), n && Kn(r, n), r;
}
function Gi(r, e, n) {
  return e in r ? Object.defineProperty(r, e, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : r[e] = n, r;
}
function Xn(r) {
  for (var e = 1; e < arguments.length; e++) {
    var n = arguments[e] != null ? arguments[e] : {}, t = Object.keys(n);
    typeof Object.getOwnPropertySymbols == "function" && (t = t.concat(Object.getOwnPropertySymbols(n).filter(function(i) {
      return Object.getOwnPropertyDescriptor(n, i).enumerable;
    }))), t.forEach(function(i) {
      Gi(r, i, n[i]);
    });
  }
  return r;
}
function Wi(r, e) {
  var n = Object.keys(r);
  if (Object.getOwnPropertySymbols) {
    var t = Object.getOwnPropertySymbols(r);
    e && (t = t.filter(function(i) {
      return Object.getOwnPropertyDescriptor(r, i).enumerable;
    })), n.push.apply(n, t);
  }
  return n;
}
function er(r, e) {
  return e = e ?? {}, Object.getOwnPropertyDescriptors ? Object.defineProperties(r, Object.getOwnPropertyDescriptors(e)) : Wi(Object(e)).forEach(function(n) {
    Object.defineProperty(r, n, Object.getOwnPropertyDescriptor(e, n));
  }), r;
}
function Pr(r) {
  "@swc/helpers - typeof";
  return r && typeof Symbol < "u" && r.constructor === Symbol ? "symbol" : typeof r;
}
function jt(r, e) {
  var n, t, i, c, o = { label: 0, sent: function() {
    if (i[0] & 1)
      throw i[1];
    return i[1];
  }, trys: [], ops: [] };
  return c = { next: d(0), throw: d(1), return: d(2) }, typeof Symbol == "function" && (c[Symbol.iterator] = function() {
    return this;
  }), c;
  function d(s) {
    return function(l) {
      return u([s, l]);
    };
  }
  function u(s) {
    if (n)
      throw new TypeError("Generator is already executing.");
    for (; o; )
      try {
        if (n = 1, t && (i = s[0] & 2 ? t.return : s[0] ? t.throw || ((i = t.return) && i.call(t), 0) : t.next) && !(i = i.call(t, s[1])).done)
          return i;
        switch (t = 0, i && (s = [s[0] & 2, i.value]), s[0]) {
          case 0:
          case 1:
            i = s;
            break;
          case 4:
            return o.label++, { value: s[1], done: !1 };
          case 5:
            o.label++, t = s[1], s = [0];
            continue;
          case 7:
            s = o.ops.pop(), o.trys.pop();
            continue;
          default:
            if (i = o.trys, !(i = i.length > 0 && i[i.length - 1]) && (s[0] === 6 || s[0] === 2)) {
              o = 0;
              continue;
            }
            if (s[0] === 3 && (!i || s[1] > i[0] && s[1] < i[3])) {
              o.label = s[1];
              break;
            }
            if (s[0] === 6 && o.label < i[1]) {
              o.label = i[1], i = s;
              break;
            }
            if (i && o.label < i[2]) {
              o.label = i[2], o.ops.push(s);
              break;
            }
            i[2] && o.ops.pop(), o.trys.pop();
            continue;
        }
        s = e.call(r, o);
      } catch (l) {
        s = [6, l], t = 0;
      } finally {
        n = i = 0;
      }
    if (s[0] & 5)
      throw s[1];
    return { value: s[0] ? s[1] : void 0, done: !0 };
  }
}
var Qi = Object.defineProperty, Ji = function(r, e, n) {
  return e in r ? Qi(r, e, { enumerable: !0, configurable: !0, writable: !0, value: n }) : r[e] = n;
}, dn = function(r, e, n) {
  return Ji(r, (typeof e > "u" ? "undefined" : Pr(e)) != "symbol" ? e + "" : e, n), n;
}, Zi = { Accept: "application/json", "Content-Type": "application/json" }, qi = "POST", tr = { headers: Zi, method: qi }, Yi = function() {
  function r(e) {
    if (Vi(this, r), this.url = e, dn(this, "events", new _r()), dn(this, "isAvailable", !1), dn(this, "registering", !1), !Qn(e))
      throw new Error("Provided URL is not compatible with HTTP connection: ".concat(e));
    this.url = e;
  }
  return Hi(r, [{ key: "connected", get: function() {
    return this.isAvailable;
  } }, { key: "connecting", get: function() {
    return this.registering;
  } }, { key: "open", value: function() {
    var n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.url, t = this;
    return Bt(function() {
      return jt(this, function(i) {
        switch (i.label) {
          case 0:
            return [4, t.register(n)];
          case 1:
            return i.sent(), [2];
        }
      });
    })();
  } }, { key: "close", value: function() {
    var n = this;
    return Bt(function() {
      return jt(this, function(t) {
        if (!n.isAvailable)
          throw new Error("Connection already closed");
        return n.onClose(), [2];
      });
    })();
  } }, { key: "request", value: function(e) {
    var n = this;
    return Bt(function() {
      var t, i, c, o, d;
      return jt(this, function(u) {
        switch (u.label) {
          case 0:
            return se.debug("HttpClient ~ request ~ payload:", e), t = n.isAvailable, t ? [3, 2] : [4, n.register()];
          case 1:
            t = u.sent(), u.label = 2;
          case 2:
            u.label = 3;
          case 3:
            return u.trys.push([3, 6, , 7]), i = Jn(e), [4, qn(n.url, er(Xn({}, tr), { body: i }))];
          case 4:
            return [4, u.sent().json()];
          case 5:
            return c = u.sent(), o = typeof c == "string" ? bi(c) : c, [2, (se.debug("HttpClient ~ request ~ result:", o), o)];
          case 6:
            return d = u.sent(), [2, n.formatError(e.id, d)];
          case 7:
            return [2];
        }
      });
    })();
  } }, { key: "formatError", value: function(e, n) {
    var t = this.parseError(n), i = t.message || t.toString();
    return yi(e, i);
  } }, { key: "register", value: function() {
    var n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.url, t = this;
    return Bt(function() {
      var i, c, o;
      return jt(this, function(d) {
        switch (d.label) {
          case 0:
            if (!Qn(n))
              throw new Error("Provided URL is not compatible with HTTP connection: ".concat(n));
            if (t.registering)
              return [2, new Promise(function(u, s) {
                t.events.once("register_error", function(l) {
                  s(l);
                }), t.events.once("open", function() {
                  if (Pr(t.isAvailable) > "u")
                    return s(new Error("HTTP connection is missing or invalid"));
                  u();
                });
              })];
            t.url = n, t.registering = !0, d.label = 1;
          case 1:
            return d.trys.push([1, 3, , 4]), i = Jn({ id: 1, jsonrpc: "2.0", method: "test", params: [] }), [4, qn(n, er(Xn({}, tr), { body: i }))];
          case 2:
            return d.sent(), t.onOpen(), [3, 4];
          case 3:
            throw c = d.sent(), o = t.parseError(c), t.events.emit("register_error", o), t.onClose(), o;
          case 4:
            return [2];
        }
      });
    })();
  } }, { key: "onOpen", value: function() {
    this.isAvailable = !0, this.registering = !1, this.events.emit("open");
  } }, { key: "onClose", value: function() {
    this.isAvailable = !1, this.registering = !1, this.events.emit("open");
  } }, { key: "parseError", value: function(e) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.url;
    return gi(e, n, "HTTP");
  } }]), r;
}(), mn, Dt = Ui;
if (Vt.env.NODE_ENV === "production")
  mn = Dt.createRoot, Dt.hydrateRoot;
else {
  var nr = Dt.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
  mn = function(r, e) {
    nr.usingClientEntryPoint = !0;
    try {
      return Dt.createRoot(r, e);
    } finally {
      nr.usingClientEntryPoint = !1;
    }
  };
}
var Ki = Object.defineProperty, Wt = Object.getOwnPropertySymbols, Br = Object.prototype.hasOwnProperty, jr = Object.prototype.propertyIsEnumerable, rr = (r, e, n) => e in r ? Ki(r, e, { enumerable: !0, configurable: !0, writable: !0, value: n }) : r[e] = n, Xi = (r, e) => {
  for (var n in e || (e = {}))
    Br.call(e, n) && rr(r, n, e[n]);
  if (Wt)
    for (var n of Wt(e))
      jr.call(e, n) && rr(r, n, e[n]);
  return r;
}, eo = (r, e) => {
  var n = {};
  for (var t in r)
    Br.call(r, t) && e.indexOf(t) < 0 && (n[t] = r[t]);
  if (r != null && Wt)
    for (var t of Wt(r))
      e.indexOf(t) < 0 && jr.call(r, t) && (n[t] = r[t]);
  return n;
};
/**
 * @license QR Code generator library (TypeScript)
 * Copyright (c) Project Nayuki.
 * SPDX-License-Identifier: MIT
 */
var ue;
((r) => {
  const e = class {
    constructor(u, s, l, f) {
      if (this.version = u, this.errorCorrectionLevel = s, this.modules = [], this.isFunction = [], u < e.MIN_VERSION || u > e.MAX_VERSION)
        throw new RangeError("Version value out of range");
      if (f < -1 || f > 7)
        throw new RangeError("Mask value out of range");
      this.size = u * 4 + 17;
      let h = [];
      for (let g = 0; g < this.size; g++)
        h.push(!1);
      for (let g = 0; g < this.size; g++)
        this.modules.push(h.slice()), this.isFunction.push(h.slice());
      this.drawFunctionPatterns();
      const b = this.addEccAndInterleave(l);
      if (this.drawCodewords(b), f == -1) {
        let g = 1e9;
        for (let I = 0; I < 8; I++) {
          this.applyMask(I), this.drawFormatBits(I);
          const A = this.getPenaltyScore();
          A < g && (f = I, g = A), this.applyMask(I);
        }
      }
      c(0 <= f && f <= 7), this.mask = f, this.applyMask(f), this.drawFormatBits(f), this.isFunction = [];
    }
    static encodeText(u, s) {
      const l = r.QrSegment.makeSegments(u);
      return e.encodeSegments(l, s);
    }
    static encodeBinary(u, s) {
      const l = r.QrSegment.makeBytes(u);
      return e.encodeSegments([l], s);
    }
    static encodeSegments(u, s, l = 1, f = 40, h = -1, b = !0) {
      if (!(e.MIN_VERSION <= l && l <= f && f <= e.MAX_VERSION) || h < -1 || h > 7)
        throw new RangeError("Invalid value");
      let g, I;
      for (g = l; ; g++) {
        const O = e.getNumDataCodewords(g, s) * 8, D = d.getTotalBits(u, g);
        if (D <= O) {
          I = D;
          break;
        }
        if (g >= f)
          throw new RangeError("Data too long");
      }
      for (const O of [e.Ecc.MEDIUM, e.Ecc.QUARTILE, e.Ecc.HIGH])
        b && I <= e.getNumDataCodewords(g, O) * 8 && (s = O);
      let A = [];
      for (const O of u) {
        t(O.mode.modeBits, 4, A), t(O.numChars, O.mode.numCharCountBits(g), A);
        for (const D of O.getData())
          A.push(D);
      }
      c(A.length == I);
      const Z = e.getNumDataCodewords(g, s) * 8;
      c(A.length <= Z), t(0, Math.min(4, Z - A.length), A), t(0, (8 - A.length % 8) % 8, A), c(A.length % 8 == 0);
      for (let O = 236; A.length < Z; O ^= 253)
        t(O, 8, A);
      let W = [];
      for (; W.length * 8 < A.length; )
        W.push(0);
      return A.forEach((O, D) => W[D >>> 3] |= O << 7 - (D & 7)), new e(g, s, W, h);
    }
    getModule(u, s) {
      return 0 <= u && u < this.size && 0 <= s && s < this.size && this.modules[s][u];
    }
    getModules() {
      return this.modules;
    }
    drawFunctionPatterns() {
      for (let l = 0; l < this.size; l++)
        this.setFunctionModule(6, l, l % 2 == 0), this.setFunctionModule(l, 6, l % 2 == 0);
      this.drawFinderPattern(3, 3), this.drawFinderPattern(this.size - 4, 3), this.drawFinderPattern(3, this.size - 4);
      const u = this.getAlignmentPatternPositions(), s = u.length;
      for (let l = 0; l < s; l++)
        for (let f = 0; f < s; f++)
          l == 0 && f == 0 || l == 0 && f == s - 1 || l == s - 1 && f == 0 || this.drawAlignmentPattern(u[l], u[f]);
      this.drawFormatBits(0), this.drawVersion();
    }
    drawFormatBits(u) {
      const s = this.errorCorrectionLevel.formatBits << 3 | u;
      let l = s;
      for (let h = 0; h < 10; h++)
        l = l << 1 ^ (l >>> 9) * 1335;
      const f = (s << 10 | l) ^ 21522;
      c(f >>> 15 == 0);
      for (let h = 0; h <= 5; h++)
        this.setFunctionModule(8, h, i(f, h));
      this.setFunctionModule(8, 7, i(f, 6)), this.setFunctionModule(8, 8, i(f, 7)), this.setFunctionModule(7, 8, i(f, 8));
      for (let h = 9; h < 15; h++)
        this.setFunctionModule(14 - h, 8, i(f, h));
      for (let h = 0; h < 8; h++)
        this.setFunctionModule(this.size - 1 - h, 8, i(f, h));
      for (let h = 8; h < 15; h++)
        this.setFunctionModule(8, this.size - 15 + h, i(f, h));
      this.setFunctionModule(8, this.size - 8, !0);
    }
    drawVersion() {
      if (this.version < 7)
        return;
      let u = this.version;
      for (let l = 0; l < 12; l++)
        u = u << 1 ^ (u >>> 11) * 7973;
      const s = this.version << 12 | u;
      c(s >>> 18 == 0);
      for (let l = 0; l < 18; l++) {
        const f = i(s, l), h = this.size - 11 + l % 3, b = Math.floor(l / 3);
        this.setFunctionModule(h, b, f), this.setFunctionModule(b, h, f);
      }
    }
    drawFinderPattern(u, s) {
      for (let l = -4; l <= 4; l++)
        for (let f = -4; f <= 4; f++) {
          const h = Math.max(Math.abs(f), Math.abs(l)), b = u + f, g = s + l;
          0 <= b && b < this.size && 0 <= g && g < this.size && this.setFunctionModule(b, g, h != 2 && h != 4);
        }
    }
    drawAlignmentPattern(u, s) {
      for (let l = -2; l <= 2; l++)
        for (let f = -2; f <= 2; f++)
          this.setFunctionModule(u + f, s + l, Math.max(Math.abs(f), Math.abs(l)) != 1);
    }
    setFunctionModule(u, s, l) {
      this.modules[s][u] = l, this.isFunction[s][u] = !0;
    }
    addEccAndInterleave(u) {
      const s = this.version, l = this.errorCorrectionLevel;
      if (u.length != e.getNumDataCodewords(s, l))
        throw new RangeError("Invalid argument");
      const f = e.NUM_ERROR_CORRECTION_BLOCKS[l.ordinal][s], h = e.ECC_CODEWORDS_PER_BLOCK[l.ordinal][s], b = Math.floor(e.getNumRawDataModules(s) / 8), g = f - b % f, I = Math.floor(b / f);
      let A = [];
      const Z = e.reedSolomonComputeDivisor(h);
      for (let O = 0, D = 0; O < f; O++) {
        let q = u.slice(D, D + I - h + (O < g ? 0 : 1));
        D += q.length;
        const Te = e.reedSolomonComputeRemainder(q, Z);
        O < g && q.push(0), A.push(q.concat(Te));
      }
      let W = [];
      for (let O = 0; O < A[0].length; O++)
        A.forEach((D, q) => {
          (O != I - h || q >= g) && W.push(D[O]);
        });
      return c(W.length == b), W;
    }
    drawCodewords(u) {
      if (u.length != Math.floor(e.getNumRawDataModules(this.version) / 8))
        throw new RangeError("Invalid argument");
      let s = 0;
      for (let l = this.size - 1; l >= 1; l -= 2) {
        l == 6 && (l = 5);
        for (let f = 0; f < this.size; f++)
          for (let h = 0; h < 2; h++) {
            const b = l - h, I = (l + 1 & 2) == 0 ? this.size - 1 - f : f;
            !this.isFunction[I][b] && s < u.length * 8 && (this.modules[I][b] = i(u[s >>> 3], 7 - (s & 7)), s++);
          }
      }
      c(s == u.length * 8);
    }
    applyMask(u) {
      if (u < 0 || u > 7)
        throw new RangeError("Mask value out of range");
      for (let s = 0; s < this.size; s++)
        for (let l = 0; l < this.size; l++) {
          let f;
          switch (u) {
            case 0:
              f = (l + s) % 2 == 0;
              break;
            case 1:
              f = s % 2 == 0;
              break;
            case 2:
              f = l % 3 == 0;
              break;
            case 3:
              f = (l + s) % 3 == 0;
              break;
            case 4:
              f = (Math.floor(l / 3) + Math.floor(s / 2)) % 2 == 0;
              break;
            case 5:
              f = l * s % 2 + l * s % 3 == 0;
              break;
            case 6:
              f = (l * s % 2 + l * s % 3) % 2 == 0;
              break;
            case 7:
              f = ((l + s) % 2 + l * s % 3) % 2 == 0;
              break;
            default:
              throw new Error("Unreachable");
          }
          !this.isFunction[s][l] && f && (this.modules[s][l] = !this.modules[s][l]);
        }
    }
    getPenaltyScore() {
      let u = 0;
      for (let h = 0; h < this.size; h++) {
        let b = !1, g = 0, I = [0, 0, 0, 0, 0, 0, 0];
        for (let A = 0; A < this.size; A++)
          this.modules[h][A] == b ? (g++, g == 5 ? u += e.PENALTY_N1 : g > 5 && u++) : (this.finderPenaltyAddHistory(g, I), b || (u += this.finderPenaltyCountPatterns(I) * e.PENALTY_N3), b = this.modules[h][A], g = 1);
        u += this.finderPenaltyTerminateAndCount(b, g, I) * e.PENALTY_N3;
      }
      for (let h = 0; h < this.size; h++) {
        let b = !1, g = 0, I = [0, 0, 0, 0, 0, 0, 0];
        for (let A = 0; A < this.size; A++)
          this.modules[A][h] == b ? (g++, g == 5 ? u += e.PENALTY_N1 : g > 5 && u++) : (this.finderPenaltyAddHistory(g, I), b || (u += this.finderPenaltyCountPatterns(I) * e.PENALTY_N3), b = this.modules[A][h], g = 1);
        u += this.finderPenaltyTerminateAndCount(b, g, I) * e.PENALTY_N3;
      }
      for (let h = 0; h < this.size - 1; h++)
        for (let b = 0; b < this.size - 1; b++) {
          const g = this.modules[h][b];
          g == this.modules[h][b + 1] && g == this.modules[h + 1][b] && g == this.modules[h + 1][b + 1] && (u += e.PENALTY_N2);
        }
      let s = 0;
      for (const h of this.modules)
        s = h.reduce((b, g) => b + (g ? 1 : 0), s);
      const l = this.size * this.size, f = Math.ceil(Math.abs(s * 20 - l * 10) / l) - 1;
      return c(0 <= f && f <= 9), u += f * e.PENALTY_N4, c(0 <= u && u <= 2568888), u;
    }
    getAlignmentPatternPositions() {
      if (this.version == 1)
        return [];
      {
        const u = Math.floor(this.version / 7) + 2, s = this.version == 32 ? 26 : Math.ceil((this.version * 4 + 4) / (u * 2 - 2)) * 2;
        let l = [6];
        for (let f = this.size - 7; l.length < u; f -= s)
          l.splice(1, 0, f);
        return l;
      }
    }
    static getNumRawDataModules(u) {
      if (u < e.MIN_VERSION || u > e.MAX_VERSION)
        throw new RangeError("Version number out of range");
      let s = (16 * u + 128) * u + 64;
      if (u >= 2) {
        const l = Math.floor(u / 7) + 2;
        s -= (25 * l - 10) * l - 55, u >= 7 && (s -= 36);
      }
      return c(208 <= s && s <= 29648), s;
    }
    static getNumDataCodewords(u, s) {
      return Math.floor(e.getNumRawDataModules(u) / 8) - e.ECC_CODEWORDS_PER_BLOCK[s.ordinal][u] * e.NUM_ERROR_CORRECTION_BLOCKS[s.ordinal][u];
    }
    static reedSolomonComputeDivisor(u) {
      if (u < 1 || u > 255)
        throw new RangeError("Degree out of range");
      let s = [];
      for (let f = 0; f < u - 1; f++)
        s.push(0);
      s.push(1);
      let l = 1;
      for (let f = 0; f < u; f++) {
        for (let h = 0; h < s.length; h++)
          s[h] = e.reedSolomonMultiply(s[h], l), h + 1 < s.length && (s[h] ^= s[h + 1]);
        l = e.reedSolomonMultiply(l, 2);
      }
      return s;
    }
    static reedSolomonComputeRemainder(u, s) {
      let l = s.map((f) => 0);
      for (const f of u) {
        const h = f ^ l.shift();
        l.push(0), s.forEach((b, g) => l[g] ^= e.reedSolomonMultiply(b, h));
      }
      return l;
    }
    static reedSolomonMultiply(u, s) {
      if (u >>> 8 || s >>> 8)
        throw new RangeError("Byte out of range");
      let l = 0;
      for (let f = 7; f >= 0; f--)
        l = l << 1 ^ (l >>> 7) * 285, l ^= (s >>> f & 1) * u;
      return c(l >>> 8 == 0), l;
    }
    finderPenaltyCountPatterns(u) {
      const s = u[1];
      c(s <= this.size * 3);
      const l = s > 0 && u[2] == s && u[3] == s * 3 && u[4] == s && u[5] == s;
      return (l && u[0] >= s * 4 && u[6] >= s ? 1 : 0) + (l && u[6] >= s * 4 && u[0] >= s ? 1 : 0);
    }
    finderPenaltyTerminateAndCount(u, s, l) {
      return u && (this.finderPenaltyAddHistory(s, l), s = 0), s += this.size, this.finderPenaltyAddHistory(s, l), this.finderPenaltyCountPatterns(l);
    }
    finderPenaltyAddHistory(u, s) {
      s[0] == 0 && (u += this.size), s.pop(), s.unshift(u);
    }
  };
  let n = e;
  n.MIN_VERSION = 1, n.MAX_VERSION = 40, n.PENALTY_N1 = 3, n.PENALTY_N2 = 3, n.PENALTY_N3 = 40, n.PENALTY_N4 = 10, n.ECC_CODEWORDS_PER_BLOCK = [
    [-1, 7, 10, 15, 20, 26, 18, 20, 24, 30, 18, 20, 24, 26, 30, 22, 24, 28, 30, 28, 28, 28, 28, 30, 30, 26, 28, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30],
    [-1, 10, 16, 26, 18, 24, 16, 18, 22, 22, 26, 30, 22, 22, 24, 24, 28, 28, 26, 26, 26, 26, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28],
    [-1, 13, 22, 18, 26, 18, 24, 18, 22, 20, 24, 28, 26, 24, 20, 30, 24, 28, 28, 26, 30, 28, 30, 30, 30, 30, 28, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30],
    [-1, 17, 28, 22, 16, 22, 28, 26, 26, 24, 28, 24, 28, 22, 24, 24, 30, 28, 28, 26, 28, 30, 24, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30]
  ], n.NUM_ERROR_CORRECTION_BLOCKS = [
    [-1, 1, 1, 1, 1, 1, 2, 2, 2, 2, 4, 4, 4, 4, 4, 6, 6, 6, 6, 7, 8, 8, 9, 9, 10, 12, 12, 12, 13, 14, 15, 16, 17, 18, 19, 19, 20, 21, 22, 24, 25],
    [-1, 1, 1, 1, 2, 2, 4, 4, 4, 5, 5, 5, 8, 9, 9, 10, 10, 11, 13, 14, 16, 17, 17, 18, 20, 21, 23, 25, 26, 28, 29, 31, 33, 35, 37, 38, 40, 43, 45, 47, 49],
    [-1, 1, 1, 2, 2, 4, 4, 6, 6, 8, 8, 8, 10, 12, 16, 12, 17, 16, 18, 21, 20, 23, 23, 25, 27, 29, 34, 34, 35, 38, 40, 43, 45, 48, 51, 53, 56, 59, 62, 65, 68],
    [-1, 1, 1, 2, 4, 4, 4, 5, 6, 8, 8, 11, 11, 16, 16, 18, 16, 19, 21, 25, 25, 25, 34, 30, 32, 35, 37, 40, 42, 45, 48, 51, 54, 57, 60, 63, 66, 70, 74, 77, 81]
  ], r.QrCode = n;
  function t(u, s, l) {
    if (s < 0 || s > 31 || u >>> s)
      throw new RangeError("Value out of range");
    for (let f = s - 1; f >= 0; f--)
      l.push(u >>> f & 1);
  }
  function i(u, s) {
    return (u >>> s & 1) != 0;
  }
  function c(u) {
    if (!u)
      throw new Error("Assertion error");
  }
  const o = class {
    constructor(u, s, l) {
      if (this.mode = u, this.numChars = s, this.bitData = l, s < 0)
        throw new RangeError("Invalid argument");
      this.bitData = l.slice();
    }
    static makeBytes(u) {
      let s = [];
      for (const l of u)
        t(l, 8, s);
      return new o(o.Mode.BYTE, u.length, s);
    }
    static makeNumeric(u) {
      if (!o.isNumeric(u))
        throw new RangeError("String contains non-numeric characters");
      let s = [];
      for (let l = 0; l < u.length; ) {
        const f = Math.min(u.length - l, 3);
        t(parseInt(u.substr(l, f), 10), f * 3 + 1, s), l += f;
      }
      return new o(o.Mode.NUMERIC, u.length, s);
    }
    static makeAlphanumeric(u) {
      if (!o.isAlphanumeric(u))
        throw new RangeError("String contains unencodable characters in alphanumeric mode");
      let s = [], l;
      for (l = 0; l + 2 <= u.length; l += 2) {
        let f = o.ALPHANUMERIC_CHARSET.indexOf(u.charAt(l)) * 45;
        f += o.ALPHANUMERIC_CHARSET.indexOf(u.charAt(l + 1)), t(f, 11, s);
      }
      return l < u.length && t(o.ALPHANUMERIC_CHARSET.indexOf(u.charAt(l)), 6, s), new o(o.Mode.ALPHANUMERIC, u.length, s);
    }
    static makeSegments(u) {
      return u == "" ? [] : o.isNumeric(u) ? [o.makeNumeric(u)] : o.isAlphanumeric(u) ? [o.makeAlphanumeric(u)] : [o.makeBytes(o.toUtf8ByteArray(u))];
    }
    static makeEci(u) {
      let s = [];
      if (u < 0)
        throw new RangeError("ECI assignment value out of range");
      if (u < 128)
        t(u, 8, s);
      else if (u < 16384)
        t(2, 2, s), t(u, 14, s);
      else if (u < 1e6)
        t(6, 3, s), t(u, 21, s);
      else
        throw new RangeError("ECI assignment value out of range");
      return new o(o.Mode.ECI, 0, s);
    }
    static isNumeric(u) {
      return o.NUMERIC_REGEX.test(u);
    }
    static isAlphanumeric(u) {
      return o.ALPHANUMERIC_REGEX.test(u);
    }
    getData() {
      return this.bitData.slice();
    }
    static getTotalBits(u, s) {
      let l = 0;
      for (const f of u) {
        const h = f.mode.numCharCountBits(s);
        if (f.numChars >= 1 << h)
          return 1 / 0;
        l += 4 + h + f.bitData.length;
      }
      return l;
    }
    static toUtf8ByteArray(u) {
      u = encodeURI(u);
      let s = [];
      for (let l = 0; l < u.length; l++)
        u.charAt(l) != "%" ? s.push(u.charCodeAt(l)) : (s.push(parseInt(u.substr(l + 1, 2), 16)), l += 2);
      return s;
    }
  };
  let d = o;
  d.NUMERIC_REGEX = /^[0-9]*$/, d.ALPHANUMERIC_REGEX = /^[A-Z0-9 $%*+.\/:-]*$/, d.ALPHANUMERIC_CHARSET = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ $%*+-./:", r.QrSegment = d;
})(ue || (ue = {}));
((r) => {
  ((e) => {
    const n = class {
      constructor(i, c) {
        this.ordinal = i, this.formatBits = c;
      }
    };
    let t = n;
    t.LOW = new n(0, 1), t.MEDIUM = new n(1, 0), t.QUARTILE = new n(2, 3), t.HIGH = new n(3, 2), e.Ecc = t;
  })(r.QrCode || (r.QrCode = {}));
})(ue || (ue = {}));
((r) => {
  ((e) => {
    const n = class {
      constructor(i, c) {
        this.modeBits = i, this.numBitsCharCount = c;
      }
      numCharCountBits(i) {
        return this.numBitsCharCount[Math.floor((i + 7) / 17)];
      }
    };
    let t = n;
    t.NUMERIC = new n(1, [10, 12, 14]), t.ALPHANUMERIC = new n(2, [9, 11, 13]), t.BYTE = new n(4, [8, 16, 16]), t.KANJI = new n(8, [8, 10, 12]), t.ECI = new n(7, [0, 0, 0]), e.Mode = t;
  })(r.QrSegment || (r.QrSegment = {}));
})(ue || (ue = {}));
var _e = ue;
/**
 * @license qrcode.react
 * Copyright (c) Paul O'Shannessy
 * SPDX-License-Identifier: ISC
 */
var to = {
  L: _e.QrCode.Ecc.LOW,
  M: _e.QrCode.Ecc.MEDIUM,
  Q: _e.QrCode.Ecc.QUARTILE,
  H: _e.QrCode.Ecc.HIGH
}, no = 128, ro = "L", io = "#FFFFFF", oo = "#000000", so = !1, Dr = 4, ao = 0.1;
function co(r, e = 0) {
  const n = [];
  return r.forEach(function(t, i) {
    let c = null;
    t.forEach(function(o, d) {
      if (!o && c !== null) {
        n.push(`M${c + e} ${i + e}h${d - c}v1H${c + e}z`), c = null;
        return;
      }
      if (d === t.length - 1) {
        if (!o)
          return;
        c === null ? n.push(`M${d + e},${i + e} h1v1H${d + e}z`) : n.push(`M${c + e},${i + e} h${d + 1 - c}v1H${c + e}z`);
        return;
      }
      o && c === null && (c = d);
    });
  }), n.join("");
}
function uo(r, e) {
  return r.slice().map((n, t) => t < e.y || t >= e.y + e.h ? n : n.map((i, c) => c < e.x || c >= e.x + e.w ? i : !1));
}
function lo(r, e, n, t) {
  if (t == null)
    return null;
  const i = n ? Dr : 0, c = r.length + i * 2, o = Math.floor(e * ao), d = c / e, u = (t.width || o) * d, s = (t.height || o) * d, l = t.x == null ? r.length / 2 - u / 2 : t.x * d, f = t.y == null ? r.length / 2 - s / 2 : t.y * d;
  let h = null;
  if (t.excavate) {
    let b = Math.floor(l), g = Math.floor(f), I = Math.ceil(u + l - b), A = Math.ceil(s + f - g);
    h = { x: b, y: g, w: I, h: A };
  }
  return { x: l, y: f, h: s, w: u, excavation: h };
}
(function() {
  try {
    new Path2D().addPath(new Path2D());
  } catch {
    return !1;
  }
  return !0;
})();
function fo(r) {
  const e = r, {
    value: n,
    size: t = no,
    level: i = ro,
    bgColor: c = io,
    fgColor: o = oo,
    includeMargin: d = so,
    imageSettings: u
  } = e, s = eo(e, [
    "value",
    "size",
    "level",
    "bgColor",
    "fgColor",
    "includeMargin",
    "imageSettings"
  ]);
  let l = _e.QrCode.encodeText(n, to[i]).getModules();
  const f = d ? Dr : 0, h = l.length + f * 2, b = lo(l, t, d, u);
  let g = null;
  u != null && b != null && (b.excavation != null && (l = uo(l, b.excavation)), g = /* @__PURE__ */ w.createElement("image", {
    xlinkHref: u.src,
    height: b.h,
    width: b.w,
    x: b.x + f,
    y: b.y + f,
    preserveAspectRatio: "none"
  }));
  const I = co(l, f);
  return /* @__PURE__ */ w.createElement("svg", Xi({
    height: t,
    width: t,
    viewBox: `0 0 ${h} ${h}`
  }, s), /* @__PURE__ */ w.createElement("path", {
    fill: c,
    d: `M0,0 h${h}v${h}H0z`,
    shapeRendering: "crispEdges"
  }), /* @__PURE__ */ w.createElement("path", {
    fill: o,
    d: I,
    shapeRendering: "crispEdges"
  }), g);
}
function ir(r, e) {
  (e == null || e > r.length) && (e = r.length);
  for (var n = 0, t = new Array(e); n < e; n++)
    t[n] = r[n];
  return t;
}
function ho(r) {
  if (Array.isArray(r))
    return r;
}
function or(r, e, n, t, i, c, o) {
  try {
    var d = r[c](o), u = d.value;
  } catch (s) {
    n(s);
    return;
  }
  d.done ? e(u) : Promise.resolve(u).then(t, i);
}
function po(r) {
  return function() {
    var e = this, n = arguments;
    return new Promise(function(t, i) {
      var c = r.apply(e, n);
      function o(u) {
        or(c, t, i, o, d, "next", u);
      }
      function d(u) {
        or(c, t, i, o, d, "throw", u);
      }
      o(void 0);
    });
  };
}
function mo(r, e, n) {
  return e in r ? Object.defineProperty(r, e, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : r[e] = n, r;
}
function yo(r, e) {
  var n = r == null ? null : typeof Symbol < "u" && r[Symbol.iterator] || r["@@iterator"];
  if (n != null) {
    var t = [], i = !0, c = !1, o, d;
    try {
      for (n = n.call(r); !(i = (o = n.next()).done) && (t.push(o.value), !(e && t.length === e)); i = !0)
        ;
    } catch (u) {
      c = !0, d = u;
    } finally {
      try {
        !i && n.return != null && n.return();
      } finally {
        if (c)
          throw d;
      }
    }
    return t;
  }
}
function go() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function we(r) {
  for (var e = 1; e < arguments.length; e++) {
    var n = arguments[e] != null ? arguments[e] : {}, t = Object.keys(n);
    typeof Object.getOwnPropertySymbols == "function" && (t = t.concat(Object.getOwnPropertySymbols(n).filter(function(i) {
      return Object.getOwnPropertyDescriptor(n, i).enumerable;
    }))), t.forEach(function(i) {
      mo(r, i, n[i]);
    });
  }
  return r;
}
function $r(r, e) {
  if (r == null)
    return {};
  var n = bo(r, e), t, i;
  if (Object.getOwnPropertySymbols) {
    var c = Object.getOwnPropertySymbols(r);
    for (i = 0; i < c.length; i++)
      t = c[i], !(e.indexOf(t) >= 0) && Object.prototype.propertyIsEnumerable.call(r, t) && (n[t] = r[t]);
  }
  return n;
}
function bo(r, e) {
  if (r == null)
    return {};
  var n = {}, t = Object.keys(r), i, c;
  for (c = 0; c < t.length; c++)
    i = t[c], !(e.indexOf(i) >= 0) && (n[i] = r[i]);
  return n;
}
function Qt(r, e) {
  return ho(r) || yo(r, e) || wo(r, e) || go();
}
function wo(r, e) {
  if (r) {
    if (typeof r == "string")
      return ir(r, e);
    var n = Object.prototype.toString.call(r).slice(8, -1);
    if (n === "Object" && r.constructor && (n = r.constructor.name), n === "Map" || n === "Set")
      return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return ir(r, e);
  }
}
function ko(r, e) {
  var n, t, i, c, o = { label: 0, sent: function() {
    if (i[0] & 1)
      throw i[1];
    return i[1];
  }, trys: [], ops: [] };
  return c = { next: d(0), throw: d(1), return: d(2) }, typeof Symbol == "function" && (c[Symbol.iterator] = function() {
    return this;
  }), c;
  function d(s) {
    return function(l) {
      return u([s, l]);
    };
  }
  function u(s) {
    if (n)
      throw new TypeError("Generator is already executing.");
    for (; o; )
      try {
        if (n = 1, t && (i = s[0] & 2 ? t.return : s[0] ? t.throw || ((i = t.return) && i.call(t), 0) : t.next) && !(i = i.call(t, s[1])).done)
          return i;
        switch (t = 0, i && (s = [s[0] & 2, i.value]), s[0]) {
          case 0:
          case 1:
            i = s;
            break;
          case 4:
            return o.label++, { value: s[1], done: !1 };
          case 5:
            o.label++, t = s[1], s = [0];
            continue;
          case 7:
            s = o.ops.pop(), o.trys.pop();
            continue;
          default:
            if (i = o.trys, !(i = i.length > 0 && i[i.length - 1]) && (s[0] === 6 || s[0] === 2)) {
              o = 0;
              continue;
            }
            if (s[0] === 3 && (!i || s[1] > i[0] && s[1] < i[3])) {
              o.label = s[1];
              break;
            }
            if (s[0] === 6 && o.label < i[1]) {
              o.label = i[1], i = s;
              break;
            }
            if (i && o.label < i[2]) {
              o.label = i[2], o.ops.push(s);
              break;
            }
            i[2] && o.ops.pop(), o.trys.pop();
            continue;
        }
        s = e.call(r, o);
      } catch (l) {
        s = [6, l], t = 0;
      } finally {
        n = i = 0;
      }
    if (s[0] & 5)
      throw s[1];
    return { value: s[0] ? s[1] : void 0, done: !0 };
  }
}
var vo = `.pointer-events-auto {
  pointer-events: auto;
}

.fixed {
  position: fixed;
}

.absolute {
  position: absolute;
}

.relative {
  position: relative;
}

.bottom-0 {
  bottom: 0px;
}

.left-0 {
  left: 0px;
}

.top-0 {
  top: 0px;
}

.top-2\\/4 {
  top: 50%;
}

.m-auto {
  margin: auto;
}

.mx-\\[4px\\] {
  margin-left: 4px;
  margin-right: 4px;
}

.mb-4 {
  margin-bottom: 1rem;
}

.mb-6 {
  margin-bottom: 1.5rem;
}

.ml-1 {
  margin-left: 0.25rem;
}

.mt-6 {
  margin-top: 1.5rem;
}

.mt-\\[35px\\] {
  margin-top: 35px;
}

.flex {
  display: flex;
}

.grid {
  display: grid;
}

.h-\\[200px\\] {
  height: 200px;
}

.h-\\[24px\\] {
  height: 24px;
}

.h-\\[40px\\] {
  height: 40px;
}

.h-\\[52px\\] {
  height: 52px;
}

.h-full {
  height: 100%;
}

.w-\\[150px\\] {
  width: 150px;
}

.w-\\[200px\\] {
  width: 200px;
}

.w-\\[20px\\] {
  width: 20px;
}

.w-\\[24px\\] {
  width: 24px;
}

.w-\\[343px\\] {
  width: 343px;
}

.w-\\[60px\\] {
  width: 60px;
}

.w-\\[75px\\] {
  width: 75px;
}

.w-full {
  width: 100%;
}

.translate-y-\\[-50\\%\\] {
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.cursor-pointer {
  cursor: pointer;
}

.grid-flow-col {
  grid-auto-flow: column;
}

.grid-cols-2 {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

.items-center {
  align-items: center;
}

.justify-end {
  justify-content: flex-end;
}

.justify-center {
  justify-content: center;
}

.justify-between {
  justify-content: space-between;
}

.gap-x-4 {
  -moz-column-gap: 1rem;
       column-gap: 1rem;
}

.gap-y-2 {
  row-gap: 0.5rem;
}

.rounded {
  border-radius: 0.25rem;
}

.rounded-2xl {
  border-radius: 1rem;
}

.rounded-lg {
  border-radius: 0.5rem;
}

.rounded-t-2xl {
  border-top-left-radius: 1rem;
  border-top-right-radius: 1rem;
}

.border {
  border-width: 1px;
}

.border-b {
  border-bottom-width: 1px;
}

.border-gray-300 {
  --tw-border-opacity: 1;
  border-color: rgb(209 213 219 / var(--tw-border-opacity));
}

.bg-black\\/\\[\\.80\\] {
  background-color: rgb(0 0 0 / .80);
}

.bg-white {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
}

.p-\\[12px\\] {
  padding: 12px;
}

.px-4 {
  padding-left: 1rem;
  padding-right: 1rem;
}

.px-6 {
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}

.py-3 {
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}

.py-4 {
  padding-top: 1rem;
  padding-bottom: 1rem;
}

.pb-6 {
  padding-bottom: 1.5rem;
}

.pt-\\[20px\\] {
  padding-top: 20px;
}

.text-center {
  text-align: center;
}

.text-base {
  font-size: 1rem;
  line-height: 1.5rem;
}

.font-medium {
  font-weight: 500;
}

.text-\\[\\#1E2329\\] {
  --tw-text-opacity: 1;
  color: rgb(30 35 41 / var(--tw-text-opacity));
}

.text-\\[\\#929AA5\\] {
  --tw-text-opacity: 1;
  color: rgb(146 154 165 / var(--tw-text-opacity));
}

.shadow-inner {
  --tw-shadow: inset 0 2px 4px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: inset 0 2px 4px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.duration-300 {
  transition-duration: 300ms;
}

.ease-in-out {
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}

.will-change-auto {
  will-change: auto;
}

.will-change-transform {
  will-change: transform;
}

.body3 {
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
}

.subtitle1 {
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: 28px;
}

.subtitle3 {
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
  /* 150% */
}

.caption2 {
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
}

.t-black {
  color: #0b0e11;
}

.t-brand {
  color: #c99400;
}

.t-primary {
  color: #202630;
}

.t-secondary {
  color: #474d57;
}

.bg-primary {
  background: #fcd535;
}

@media (min-width: 768px) {
  .md\\:subtitle1 {
    font-size: 20px;
    font-style: normal;
    font-weight: 600;
    line-height: 28px;
  }

  .md\\:w-\\[400px\\] {
    width: 400px;
  }

  .md\\:font-semibold {
    font-weight: 600;
  }
}

@media (min-width: 1024px) {
  .lg\\:p-8 {
    padding: 2rem;
  }

  .lg\\:pt-6 {
    padding-top: 1.5rem;
  }

  .lg\\:text-xl {
    font-size: 1.25rem;
    line-height: 1.75rem;
  }
}
`, Eo = `
`.concat(vo, `
*, :before, :after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x: ;
  --tw-pan-y: ;
  --tw-pinch-zoom: ;
  --tw-scroll-snap-strictness: proximity;
  --tw-ordinal: ;
  --tw-slashed-zero: ;
  --tw-numeric-figure: ;
  --tw-numeric-spacing: ;
  --tw-numeric-fraction: ;
  --tw-ring-inset: ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / .5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur: ;
  --tw-brightness: ;
  --tw-contrast: ;
  --tw-grayscale: ;
  --tw-hue-rotate: ;
  --tw-invert: ;
  --tw-saturate: ;
  --tw-sepia: ;
  --tw-drop-shadow: ;
  --tw-backdrop-blur: ;
  --tw-backdrop-brightness: ;
  --tw-backdrop-contrast: ;
  --tw-backdrop-grayscale: ;
  --tw-backdrop-hue-rotate: ;
  --tw-backdrop-invert: ;
  --tw-backdrop-opacity: ;
  --tw-backdrop-saturate: ;
  --tw-backdrop-sepia: ;
}
:root {
  --animation-duration: 300ms;
}


@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes fadeOut {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
}

.animated {
  animation-duration: var(--animation-duration);
  animation-fill-mode: both;
}

.fadeIn {
  animation-name: fadeIn;
}

.fadeOut {
  animation-name: fadeOut;
}

#binanceW3W-wrapper {
  -webkit-user-select: none;
  align-items: center;
  display: flex;
  height: 100%;
  justify-content: center;
  left: 0;
  pointer-events: none;
  position: fixed;
  top: 0;
  user-select: none;
  width: 100%;
  z-index: 99999999999999;
}
`), Lr = Li({}), xo = function() {
  return Fi(Lr);
}, zr = "binanceW3W-wrapper", yn = "binanceW3W-qrcode-modal", sr = { googlePlay: "https://app.appsflyer.com/com.binance.dev?pid=https%3A%2F%2Fwww.binance.com%2Fen&c=https%3A%2F%2Fwww.binance.com%2Fen", appleStore: "https://app.appsflyer.com/id1436799971?pid=https%3A%2F%2Fwww.binance.com%2Fen&c=https%3A%2F%2Fwww.binance.com%2Fen" }, Co = "PHN2ZyB3aWR0aD0iNTYiIGhlaWdodD0iNTYiIHZpZXdCb3g9IjAgMCA1NiA1NiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3QgeD0iMiIgeT0iMiIgd2lkdGg9IjUyIiBoZWlnaHQ9IjUyIiByeD0iMTAiIGZpbGw9IiMxNDE1MUEiIHN0cm9rZT0id2hpdGUiIHN0cm9rZS13aWR0aD0iNCIvPgo8cGF0aCBkPSJNMTIgMjhMMTUuNjEyOSAyNC4zODcxTDE5LjIyNTggMjhMMTUuNjEyOSAzMS42MTI5TDEyIDI4WiIgZmlsbD0iI0YwQjkwQiIvPgo8cGF0aCBkPSJNMTguMTkzNSAyMS44MDY1TDI4IDEyTDM3LjgwNjUgMjEuODA2NUwzNC4xOTM2IDI1LjQxOTRMMjggMTkuMjI1OEwyMS44MDY1IDI1LjQxOTRMMTguMTkzNSAyMS44MDY1WiIgZmlsbD0iI0YwQjkwQiIvPgo8cGF0aCBkPSJNMjQuMzg3MSAyOEwyOCAyNC4zODcxTDMxLjYxMjkgMjhMMjggMzEuNjEyOUwyNC4zODcxIDI4WiIgZmlsbD0iI0YwQjkwQiIvPgo8cGF0aCBkPSJNMjEuODA2NSAzMC41ODA2TDE4LjE5MzUgMzQuMTkzNUwyOCA0NEwzNy44MDY1IDM0LjE5MzVMMzQuMTkzNiAzMC41ODA2TDI4IDM2Ljc3NDJMMjEuODA2NSAzMC41ODA2WiIgZmlsbD0iI0YwQjkwQiIvPgo8cGF0aCBkPSJNMzYuNzc0MiAyOEw0MC4zODcxIDI0LjM4NzFMNDQgMjhMNDAuMzg3MSAzMS42MTI5TDM2Ljc3NDIgMjhaIiBmaWxsPSIjRjBCOTBCIi8+Cjwvc3ZnPgo=", Fr = "data:image/svg+xml;base64,".concat(Co), Ur = function() {
  var r = Qt(Gt(), 2), e = r[0], n = r[1], t = Qt(Gt(!1), 2), i = t[0], c = t[1];
  return Tr(function() {
    var o = wi(), d = ki();
    n(o), c(d);
  }, []), { isMobile: e, isAndroid: i };
}, Ao = ["en", "ar", "bg-BG", "zh-CN", "zh-TW", "cs-CZ", "fr-FR", "de-DE", "el-GR", "id-ID", "it-IT", "kk-KZ", "lv-LV", "pl-PL", "pt-BR", "pt-PT", "ro-RO", "ru-RU", "sk-SK", "sl-SI", "es-LA", "es-ES", "sv-SE", "tr-TR", "uk-UA", "vi-VN", "da-DK", "my-MM", "lo-LA", "si-LK"], _o = { "sdk-download-android": "تنزيل لنظام Android", "sdk-connect": "اتصال", "sdk-download-ios": "تنزيل لنظام iOS", "sdk-install": "تثبيت", "sdk-modal-instruct-1": "1. افتح تطبيق Binance", "sdk-modal-instruct-2": "2. اضغط {{icon}} على الشاشة الرئيسية", "sdk-modal-title": "الربط مع Binance (بينانس)", "sdk-no-app": "ليس لديك تطبيق Binance حتّى الآن؟" }, So = { "sdk-download-android": "Изтегляне за Android", "sdk-connect": "Свържи", "sdk-download-ios": "Изтегляне за iOS", "sdk-install": "Инсталиране", "sdk-modal-instruct-1": "1. Отворете приложението Binance", "sdk-modal-instruct-2": "2. Докоснете {{icon}} на началния екран", "sdk-modal-title": "Свържете се с Binance", "sdk-no-app": "Все още нямате приложението Binance?" }, Io = { "sdk-download-android": "Stáhnout pro Android", "sdk-connect": "Připojit", "sdk-download-ios": "Stáhnout pro iOS", "sdk-install": "Instalovat", "sdk-modal-instruct-1": "1. Otevřete aplikaci Binance", "sdk-modal-instruct-2": "2. Klepněte na {{icon}} na domovské obrazovce", "sdk-modal-title": "Připojit platformu Binance", "sdk-no-app": "Ještě nemáte aplikaci Binance?" }, Oo = { "sdk-download-android": "Download til Android", "sdk-connect": "Forbind", "sdk-download-ios": "Download til iOS", "sdk-install": "Installer", "sdk-modal-instruct-1": "1. Åbn Binance-appen", "sdk-modal-instruct-2": "2. Tryk på {{icon}} på startskærmen", "sdk-modal-title": "Forbind til Binance", "sdk-no-app": "Har du ikke Binance-appen endnu?" }, Mo = { "sdk-download-android": "Für Android herunterladen", "sdk-connect": "Verbinden", "sdk-download-ios": "Für iOS herunterladen", "sdk-install": "Installieren", "sdk-modal-instruct-1": "1. Binance-App öffnen", "sdk-modal-instruct-2": "2. Tippe auf dem Startbildschirm auf {{icon}}", "sdk-modal-title": "Mit Binance verknüpfen", "sdk-no-app": "Du hast die Binance-App noch nicht?" }, No = { "sdk-download-android": "Λήψη για Android", "sdk-connect": "Συνδεθείτε", "sdk-download-ios": "Λήψη για iOS", "sdk-install": "Εγκατάσταση", "sdk-modal-instruct-1": "1. Ανοίξτε την εφαρμογή Binance", "sdk-modal-instruct-2": "2. Πατήστε {{icon}} στην αρχική οθόνη", "sdk-modal-title": "Συνδεθείτε με την Binance", "sdk-no-app": "Δεν έχετε ακόμα την εφαρμογή Binance;" }, Ro = { "sdk-download-android": "Download for Android", "sdk-connect": "Connect", "sdk-download-ios": "Download for iOS", "sdk-install": "Install", "sdk-modal-instruct-1": "1. Open Binance app", "sdk-modal-instruct-2": "2. Tap {{icon}} on Home Screen", "sdk-modal-title": "Connect With Binance", "sdk-no-app": "Don’t have the Binance app yet?" }, To = { "sdk-download-android": "Descargar para Android", "sdk-connect": "Conectar", "sdk-download-ios": "Descargar para iOS", "sdk-install": "Instalar", "sdk-modal-instruct-1": "1. Open Binance app", "sdk-modal-instruct-2": "2. Pulsa en {{icon}} en la página principal", "sdk-modal-title": "Connect With Binance", "sdk-no-app": "¿Aún no tienes la aplicación de Binance?" }, Po = { "sdk-download-android": "Descargar para Android", "sdk-connect": "Conecta", "sdk-download-ios": "Descargar para iOS", "sdk-install": "Instala", "sdk-modal-instruct-1": "1. Abre la aplicación de Binance", "sdk-modal-instruct-2": "2. Toca {{icon}} en la pantalla de inicio", "sdk-modal-title": "Conectar con Binance", "sdk-no-app": "¿Aún no tienes la aplicación de Binance?" }, Bo = { "sdk-download-android": "Télécharger pour Android", "sdk-connect": "Se connecter", "sdk-download-ios": "Télécharger pour iOS", "sdk-install": "Installer", "sdk-modal-instruct-1": "1. Ouvrez l’application de Binance", "sdk-modal-instruct-2": "2. Appuyez sur {{icon}} sur l’écran d’accueil", "sdk-modal-title": "Se connecter à Binance", "sdk-no-app": "Vous n’avez pas encore l’application de Binance ?" }, jo = { "sdk-download-android": "Unduh untuk Android", "sdk-connect": "Terhubung", "sdk-download-ios": "Unduh untuk iOS", "sdk-install": "Instal", "sdk-modal-instruct-1": "1. Buka aplikasi Binance", "sdk-modal-instruct-2": "2. Ketuk {{icon}} di Layar Beranda", "sdk-modal-title": "Hubungkan dengan Binance", "sdk-no-app": "Belum punya aplikasi Binance?" }, Do = { "sdk-download-android": "Scarica per Android", "sdk-connect": "Collega", "sdk-download-ios": "Scarica per iOS", "sdk-install": "Installa", "sdk-modal-instruct-1": "1. Apri l'app Binance", "sdk-modal-instruct-2": "2. Tocca {{icon}} nella homepage", "sdk-modal-title": "Collega con Binance", "sdk-no-app": "Non hai ancora l'app Binance?" }, $o = { "sdk-download-android": "Android үшін жүктеп алу", "sdk-connect": "Қосылу", "sdk-download-ios": "iOS үшін жүктеп алу", "sdk-install": "Орнату", "sdk-modal-instruct-1": "1. Binance қолданбасын ашыңыз", "sdk-modal-instruct-2": "2. Басты экрандағы {{icon}} белгішесін түртіңіз", "sdk-modal-title": "Binance платформасымен байланыстыру", "sdk-no-app": "Сізде әлі Binance қолданбасы жоқ па?" }, Lo = { "sdk-download-android": "ດາວໂຫຼດສໍາລັບ Android", "sdk-connect": "ເຊື່ອມຕໍ່", "sdk-download-ios": "ດາວໂຫຼດສໍາລັບ iOS", "sdk-install": "ຕິດຕັ້ງ", "sdk-modal-instruct-1": "1. ເປີດແອັບ Binance", "sdk-modal-instruct-2": "2. ແຕະ {{icon}} ໃນໜ້າຈໍຫຼັກ", "sdk-modal-title": "ເຊື່ອມຕໍ່ກັບ Binance", "sdk-no-app": "ຍັງບໍ່ມີແອັບ Binance ເທື່ອບໍ?" }, zo = { "sdk-download-android": "Lejupielādēt Android ierīcei", "sdk-connect": "Savienot", "sdk-download-ios": "Lejupielādēt iOS ierīcei", "sdk-install": "Instalēt", "sdk-modal-instruct-1": "1. Atver Binance lietotni", "sdk-modal-instruct-2": "2. Pieskaries pie {{icon}} sākuma ekrānā", "sdk-modal-title": "Savieno ar Binance", "sdk-no-app": "Vai tev vēl nav Binance lietotnes?" }, Fo = { "sdk-download-android": "အန်းဒရွိုက်အတွက် ဒေါင်းလုဒ်လုပ်မည်", "sdk-connect": "ချိတ်ဆက်မည်", "sdk-download-ios": "iOS အတွက် ဒေါင်းလုဒ်လုပ်မည်", "sdk-install": "ထည့်သွင်းမည်", "sdk-modal-instruct-1": "1. Open Binance app", "sdk-modal-instruct-2": "ပင်မမျက်နှာပြင်မှ {{icon}} ကိုနှိပ်ပါ။", "sdk-modal-title": "Connect With Binance", "sdk-no-app": "Binance App မရှိသေးဘူးလား။" }, Uo = { "sdk-download-android": "Pobierz na Androida", "sdk-connect": "Połącz", "sdk-download-ios": "Pobierz na iOS", "sdk-install": "Zainstaluj", "sdk-modal-instruct-1": "1. Otwórz Aplikację Binance", "sdk-modal-instruct-2": "2. Kliknij {{icon}} na ekranie głównym", "sdk-modal-title": "Połącz z Binance", "sdk-no-app": "Nie masz jeszcze aplikacji Binance?" }, Vo = { "sdk-download-android": "Baixar para Android", "sdk-connect": "Conecte", "sdk-download-ios": "Baixar para iOS", "sdk-install": "Instalar", "sdk-modal-instruct-1": "1. Abra o Aplicativo da Binance", "sdk-modal-instruct-2": "2. Toque em {{icon}} na Tela Inicial", "sdk-modal-title": "Conectar com a Binance", "sdk-no-app": "Ainda não tem o aplicativo da Binance?" }, Ho = { "sdk-download-android": "Transferir para Android", "sdk-connect": "Associar", "sdk-download-ios": "Transferir para iOS", "sdk-install": "Instalar", "sdk-modal-instruct-1": "1. Abre a aplicação Binance", "sdk-modal-instruct-2": "2. Toca em {{icon}} no Ecrã Inicial", "sdk-modal-title": "Associa com a Binance", "sdk-no-app": "Ainda não tens a aplicação Binance?" }, Go = { "sdk-download-android": "Descărcați pentru Android", "sdk-connect": "Conectare", "sdk-download-ios": "Descărcați pentru iOS", "sdk-install": "Instalați", "sdk-modal-instruct-1": "1. Deschideți aplicația Binance", "sdk-modal-instruct-2": "2. Atingeți {{icon}} pe ecranul de pornire", "sdk-modal-title": "Conectați-vă cu Binance", "sdk-no-app": "Nu aveți încă aplicația Binance?" }, Wo = { "sdk-download-android": "Скачать для Android", "sdk-connect": "Подключить", "sdk-download-ios": "Скачать для iOS", "sdk-install": "Установить", "sdk-modal-instruct-1": "1. Откройте приложение Binance", "sdk-modal-instruct-2": "2. Нажмите {{icon}} на главном экране", "sdk-modal-title": "Подключить кошелек Binance", "sdk-no-app": "У вас еще нет приложения Binance?" }, Qo = { "sdk-download-android": "Android සඳහා බාගත කරන්න", "sdk-connect": "සම්බන්ධ කරන්න", "sdk-download-ios": "iOS සඳහා බාගත කරන්න", "sdk-install": "ස්ථාපනය කරන්න", "sdk-modal-instruct-1": "1. Binance යෙදුම විවෘත කරන්න", "sdk-modal-instruct-2": "2. මුල් තිරයේ {{icon}} මත තට්ටු කරන්න", "sdk-modal-title": "Binance සමග සම්බන්ධ වන්න", "sdk-no-app": "තවමත් Binance යෙදුම නැති ද?" }, Jo = { "sdk-download-android": "Stiahnuť pre Android", "sdk-connect": "Pripojiť", "sdk-download-ios": "Stiahnuť pre iOS", "sdk-install": "Nainštalovať", "sdk-modal-instruct-1": "1. Otvorte aplikáciu Binance", "sdk-modal-instruct-2": "2. Klepnite na ikonu {{icon}} na domovskej obrazovke", "sdk-modal-title": "Spojte sa s Binance", "sdk-no-app": "Ešte nemáte aplikáciu Binance?" }, Zo = { "sdk-download-android": "Prenos za Android", "sdk-connect": "Poveži", "sdk-download-ios": "Prenos za iOS", "sdk-install": "Namesti", "sdk-modal-instruct-1": "1. Odprite aplikacijo Binance", "sdk-modal-instruct-2": "2. Tapnite {{icon}} na začetnem zaslonu", "sdk-modal-title": "Povežite se s platformo Binance", "sdk-no-app": "Še nimate aplikacije Binance?" }, qo = { "sdk-download-android": "Ladda ned för Android", "sdk-connect": "Anslut", "sdk-download-ios": "Ladda ned för iOS", "sdk-install": "Installera", "sdk-modal-instruct-1": "1. Öppna Binance-appen", "sdk-modal-instruct-2": "2. Tryck på {{icon}} på startskärmen", "sdk-modal-title": "Anslut med Binance", "sdk-no-app": "Har du inte Binance-appen ännu?" }, Yo = { "sdk-download-android": "Android için indir", "sdk-connect": "Bağlan", "sdk-download-ios": "iOS için indir", "sdk-install": "Yükle", "sdk-modal-instruct-1": "1. Binance Uygulamasını Açın", "sdk-modal-instruct-2": "2. Ana Ekranda {{icon}} simgesine dokunun", "sdk-modal-title": "Binance ile Bağlanın", "sdk-no-app": "Henüz Binance uygulamanız yok mu?" }, Ko = { "sdk-download-android": "Завантажити для Android", "sdk-connect": "Підключитись", "sdk-download-ios": "Завантажити для iOS", "sdk-install": "Встановити", "sdk-modal-instruct-1": "1. Відкрийте застосунок Binance", "sdk-modal-instruct-2": "2. Торкніться {{icon}} на головному екрані", "sdk-modal-title": "Підключіться до Binance", "sdk-no-app": "Ще не маєте застосунку Binance?" }, Xo = { "sdk-download-android": "Tải xuống cho Android", "sdk-connect": "Kết nối", "sdk-download-ios": "Tải xuống cho iOS", "sdk-install": "Cài đặt", "sdk-modal-instruct-1": "1. Mở ứng dụng Binance", "sdk-modal-instruct-2": "2. Nhấn vào {{icon}} trên Màn hình chính", "sdk-modal-title": "Kết nối với Binance", "sdk-no-app": "Bạn chưa có ứng dụng Binance?" }, es = { "sdk-download-android": "下载安卓版", "sdk-connect": "关联", "sdk-download-ios": "下载iOS版", "sdk-install": "安装", "sdk-modal-instruct-1": "1.打开币安App", "sdk-modal-instruct-2": "2.点击主屏幕的{{icon}}", "sdk-modal-title": "关联币安", "sdk-no-app": "尚未安装币安App？" }, ts = { "sdk-download-android": "Android 下載", "sdk-connect": "連接", "sdk-download-ios": "iOS 下載", "sdk-install": "安裝", "sdk-modal-instruct-1": "1. 開啟幣安 App", "sdk-modal-instruct-2": "2. 在首頁畫面上點擊 {{icon}}", "sdk-modal-title": "與幣安連接", "sdk-no-app": "還沒有幣安 App 嗎？" }, ns = { en: Ro, ar: _o, "bg-BG": So, "zh-CN": es, "zh-TW": ts, "cs-CZ": Io, "fr-FR": Bo, "de-DE": Mo, "el-GR": No, "id-ID": jo, "it-IT": Do, "kk-KZ": $o, "lv-LV": zo, "pl-PL": Uo, "pt-BR": Vo, "pt-PT": Ho, "ro-RO": Go, "ru-RU": Wo, "sk-SK": Jo, "sl-SI": Zo, "es-LA": Po, "es-ES": To, "sv-SE": qo, "tr-TR": Yo, "uk-UA": Ko, "vi-VN": Xo, "da-DK": Oo, "my-MM": Fo, "lo-LA": Lo, "si-LK": Qo }, rs = Ao.reduce(function(r, e) {
  return r[e] = ns[e], r;
}, {}), fe = rs, is = function() {
  var r = xo(), e = r.lng;
  return zi(function(n, t) {
    var i, c;
    return (fe == null || (i = fe[e]) === null || i === void 0 ? void 0 : i[n]) || (fe == null || (c = fe.en) === null || c === void 0 ? void 0 : c[n]) || (t == null ? void 0 : t.default) || n;
  }, [e]);
}, rn = is, os = function(r) {
  var e = r.size, n = e === void 0 ? 24 : e, t = r.color, i = t === void 0 ? "currentColor" : t, c = r.className, o = r.children, d = $r(r, ["size", "color", "className", "children"]);
  return w.createElement("svg", we({ width: n, height: n, fill: i, className: c, viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, d), o);
}, on = os, ss = function(r) {
  return w.createElement(on, we({ size: 24 }, r), w.createElement("path", { d: "M21.7725 18.7033C21.4062 19.5418 20.9727 20.3136 20.4704 21.0232C19.7857 21.9906 19.2251 22.6602 18.7931 23.032C18.1233 23.6424 17.4058 23.955 16.6374 23.9728C16.0857 23.9728 15.4205 23.8172 14.6461 23.5017C13.8692 23.1876 13.1552 23.032 12.5024 23.032C11.8177 23.032 11.0834 23.1876 10.2979 23.5017C9.51127 23.8172 8.87756 23.9816 8.39305 23.9979C7.65619 24.0291 6.92173 23.7076 6.1886 23.032C5.72069 22.6276 5.13542 21.9343 4.43429 20.9521C3.68203 19.9033 3.06358 18.687 2.57906 17.3004C2.06017 15.8026 1.80005 14.3523 1.80005 12.9482C1.80005 11.3398 2.15076 9.95259 2.85324 8.79011C3.40532 7.85636 4.13979 7.11979 5.05903 6.57906C5.97827 6.03834 6.97151 5.76279 8.04114 5.74516C8.62641 5.74516 9.39391 5.92456 10.3477 6.27715C11.2988 6.63091 11.9095 6.81032 12.1772 6.81032C12.3774 6.81032 13.0558 6.60054 14.2058 6.18233C15.2934 5.79449 16.2113 5.63391 16.9633 5.69716C19.0009 5.86012 20.5317 6.6561 21.5497 8.09013C19.7274 9.18432 18.826 10.7169 18.8439 12.6829C18.8603 14.2142 19.4209 15.4886 20.5227 16.5004C21.022 16.97 21.5796 17.333 22.2001 17.5907C22.0655 17.9774 21.9235 18.3477 21.7725 18.7033ZM17.0993 0.480137C17.0993 1.68041 16.6568 2.8011 15.7748 3.8384C14.7104 5.07155 13.4229 5.78412 12.0268 5.67168C12.009 5.52769 11.9987 5.37614 11.9987 5.21688C11.9987 4.06462 12.5049 2.83147 13.4038 1.82321C13.8526 1.3127 14.4234 0.888228 15.1155 0.549615C15.8062 0.216055 16.4595 0.031589 17.0739 0C17.0918 0.160458 17.0993 0.320926 17.0993 0.480121V0.480137Z", fill: "#1E2329" }));
}, as = function(r) {
  return w.createElement(on, we({ size: 24 }, r), w.createElement("path", { d: "M13.5589 11.0874L4.08203 1.59644H4.17441C4.98558 1.59644 5.68614 1.89129 6.81073 2.4993L16.7488 7.88083L13.5589 11.0874Z", fill: "#202630" }), w.createElement("path", { d: "M12.6373 12.008L2.90218 21.7203C2.66236 21.3329 2.49658 20.7063 2.49658 19.8034V4.19354C2.49658 3.29078 2.66236 2.66403 2.90218 2.2771L12.6373 12.008Z", fill: "#202630" }), w.createElement("path", { d: "M13.5589 12.9124L16.7488 16.1187L6.81073 21.5001C5.68614 22.1083 4.98548 22.4036 4.17441 22.4036H4.08203L13.5589 12.9124Z", fill: "#202630" }), w.createElement("path", { d: "M17.9437 8.52563L14.4775 12.0091L17.9437 15.4738L20.0456 14.3309C20.8199 13.9069 22 13.1329 22 12.0091C22 10.8662 20.8199 10.0922 20.0456 9.66821L17.9437 8.52563Z", fill: "#202630" }));
}, cs = function(r) {
  return w.createElement(on, we({ size: 24 }, r), w.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.5 4H10.5V7H7.5V10H4.5V7V4H7.5ZM14.5 4H17.5H20.5V7V10H17.5V7H14.5V4ZM10.5 20V17H7.5V14H4.5V17V20H7.5H10.5ZM17.5 20H14.5V17H17.5V14H20.5V17V20H17.5ZM16.5 10.5H8.5V13.5H16.5V10.5Z", fill: "#202630" }));
}, us = function(r) {
  var e = r.value, n = $r(r, ["value"]), t = ls(e).map(function(i) {
    return typeof i == "string" ? i : w.cloneElement(n[i.key], { key: i.key });
  });
  return w.createElement(w.Fragment, null, t);
}, ls = function(r) {
  for (var e = /{{(.*?)}}/g, n, t = 0, i = []; (n = e.exec(r)) !== null; )
    n.index !== t && i.push(r.substring(t, n.index)), i.push({ key: n[1] }), t = e.lastIndex;
  return t !== r.length && i.push(r.substring(t)), i;
}, ds = function() {
  var r = rn();
  return w.createElement(w.Fragment, null, w.createElement(fs, { t: r }), w.createElement(hs, { t: r }), w.createElement(ps, null));
}, fs = function(r) {
  var e = r.t;
  return w.createElement("div", { style: { borderBottom: "1px solid #EAECEF" }, className: "grid justify-center gap-y-2 pb-6 body3 t-black border-b border-gray-300" }, w.createElement("div", null, e("sdk-modal-instruct-1", { default: "1. Open Binance app" })), w.createElement("div", { className: "flex items-center" }, w.createElement(us, { value: e("sdk-modal-instruct-2", { default: "2. Tap {{icon}} on Home" }), icon: w.createElement(cs, { className: "w-[24px] h-[24px] mx-[4px]" }) })));
}, hs = function(r) {
  var e = r.t;
  return w.createElement("div", { className: "py-4 body3 t-secondary text-center" }, e("sdk-no-app", { default: "Don't have Binance app yet?" }));
}, ps = function() {
  return w.createElement("div", { className: "grid grid-cols-2 gap-x-4" }, w.createElement(ar, { type: "iOS" }), w.createElement(ar, { type: "Android" }));
}, ar = function(r) {
  var e = r.type, n = rn();
  return w.createElement("div", { style: { border: "1px solid #EAECEF" }, className: "p-[12px] rounded-lg grid cursor-pointer t-secondary grid-flow-col items-center gap-x-4 w-[150px]", onClick: function() {
    window.open(e === "Android" ? sr.googlePlay : sr.appleStore, "_blank");
  } }, e === "Android" ? w.createElement(as, { className: "w-[24px] h-[24px] m-auto" }) : w.createElement(ss, { className: "w-[24px] h-[24px] m-auto" }), w.createElement("div", { className: "w-[75px] caption2 t-secondary" }, n("sdk-download-".concat(e.toLowerCase()), { default: "Download for ".concat(e) })));
}, Vr = function(r) {
  return w.createElement(on, we({}, r), w.createElement("path", { d: "M6.69708 4.57538L4.57576 6.6967L9.87906 12L4.57576 17.3033L6.69708 19.4246L12.0004 14.1213L17.3037 19.4246L19.425 17.3033L14.1217 12L19.425 6.6967L17.3037 4.57538L12.0004 9.87868L6.69708 4.57538Z", fill: "currentColor" }));
}, ms = function(r) {
  var e = r.onClose, n = rn();
  return w.createElement("div", { className: "flex items-center justify-between" }, w.createElement("p", { className: "text-base font-medium text-[#1E2329] lg:text-xl md:font-semibold md:subtitle1" }, n("sdk-modal-title", { default: "Connect with Binance" })), w.createElement("div", { className: "cursor-pointer text-[#929AA5]", onClick: e }, w.createElement(Vr, null)));
}, ys = ms, gs = function(r) {
  var e = r.id, n = r.onClose, t = r.onConnect, i = rn();
  return w.createElement("div", { id: e, className: "animated fadeIn pointer-events-auto fixed top-0 left-0 h-full w-full bg-black/[.80] duration-300 ease-in-out will-change-auto" }, w.createElement("div", { className: "absolute bottom-0 m-auto w-full rounded-t-2xl bg-white px-4 pb-6 shadow-inner duration-300 ease-in-out will-change-transform md:w-[400px]" }, w.createElement(bs, { onClose: n }), w.createElement("div", { className: "mt-6 mb-4 flex justify-center" }, w.createElement("img", { className: "w-[60px]", src: Fr })), w.createElement("div", { className: "subtitle1 text-center mb-6 t-primary" }, i("sdk-modal-title", { default: "Connect with Binance" })), w.createElement("button", { onClick: t, style: { borderColor: "transparent" }, className: "w-full rounded h-[40px] flex justify-center items-center bg-primary t-primary subtitle3 mb-4" }, i("sdk-connect", { default: "Connect" })), w.createElement("div", { className: "text-center py-3 t-secondary" }, w.createElement("span", null, i("sdk-no-app", { default: "Don’t have Binance app yet?" })), w.createElement("a", { target: "_blank", href: "https://www.binance.com/en/download", className: "t-brand ml-1" }, i("sdk-install", { default: "Install" })))));
}, bs = function(r) {
  var e = r.onClose;
  return w.createElement("div", { className: "flex items-center justify-end h-[52px]" }, w.createElement("div", { className: "cursor-pointer text-[#929AA5]", onClick: e }, w.createElement(Vr, { className: "w-[20px]" })));
}, ws = function(r, e) {
  var n = "visibilitychange", t = setTimeout(function() {
    document.hidden || r();
  }, e), i = function() {
    document.hidden && (clearTimeout(t), document.removeEventListener(n, i));
  };
  document.addEventListener(n, i, !1);
}, ks = function(r) {
  var e = document.createElement("a");
  e.href = r, document.body.appendChild(e), ws(function() {
    window.location.href = "https://www.binance.com/en/download";
  }, 1e3), e.click(), document.body.removeChild(e);
}, vs = function(r) {
  var e = Ur(), n = e.isAndroid, t = e.isMobile;
  return { toBinance: function() {
    var i = vi(n, r);
    if (t) {
      if (!n) {
        var c = document.createElement("a");
        c.href = i, document.body.appendChild(c), c.click(), document.body.removeChild(c);
      }
      n && ks(i);
    }
  } };
};
function Es(r) {
  var e = vs(r.url), n = e.toBinance;
  return w.createElement("div", null, w.createElement("div", { className: "mt-[35px] flex justify-center" }, w.createElement("div", { className: "w-[200px] h-[200px] mb-4", onClick: n }, r.url && w.createElement(fo, { value: r.url, width: "100%", height: "100%", level: "M", imageSettings: { src: Fr, height: 32, width: 32, excavate: !1 } }))));
}
var xs = Es, Cs = function(r) {
  var e = r.onClose, n = r.isReady, t = Ur(), i = t.isMobile, c = Qt(Gt(""), 2), o = c[0], d = c[1], u = Qt(Gt(!1), 2), s = u[0], l = u[1];
  Tr(function() {
    n.then(d).catch(function() {
      return l(!0);
    });
  }, [n]);
  var f = function() {
    Sr(o);
  }, h = { url: o, error: s };
  if (i === !1)
    return w.createElement("div", { id: yn, className: "animated fadeIn pointer-events-auto fixed top-0 left-0 h-full w-full bg-black/[.80] duration-300 ease-in-out will-change-auto" }, w.createElement("div", { className: "relative top-2/4 m-auto w-[343px] translate-y-[-50%] rounded-2xl bg-white px-6 pt-[20px] pb-6 shadow-inner duration-300 ease-in-out will-change-transform md:w-[400px] lg:p-8 lg:pt-6" }, w.createElement(ys, { onClose: e }), w.createElement(xs, we({}, h)), w.createElement(ds, null)));
  if (i)
    return w.createElement(gs, { onConnect: f, onClose: e, id: yn });
}, As = Cs, cr = { order: ["querystring", "cookie", "localStorage", "sessionStorage", "navigator", "htmlTag", "path", "subdomain"], lookupQuerystring: function() {
  var e = window.location.search.match(/lng=([^&]*)/);
  return e && e[1];
}, lookupCookie: function() {
  var e = document.cookie.match(/i18next=([^;]*)/);
  return e && e[1];
}, lookupLocalStorage: function() {
  return localStorage.getItem("i18nextLng");
}, lookupSessionStorage: function() {
  return sessionStorage.getItem("i18nextLng");
}, lookupFromNavigator: function() {
  return navigator.language;
}, lookupFromHtmlTag: function() {
  return document.documentElement.lang;
}, lookupFromPath: function() {
  var e = window.location.pathname.match(/\/([^/]*)/);
  return e && e[1];
}, lookupFromSubdomain: function() {
  var e = window.location.hostname.match(/^(.+)\./);
  return e && e[1];
} }, _s = function() {
  var r = !0, e = !1, n = void 0;
  try {
    for (var t = cr.order[Symbol.iterator](), i; !(r = (i = t.next()).done); r = !0) {
      var c = i.value;
      try {
        var o = cr["lookup" + c.charAt(0).toUpperCase() + c.slice(1)]();
        if (o)
          return o;
      } catch (d) {
        console.error("Error detecting language with method: ".concat(c), d);
        continue;
      }
    }
  } catch (d) {
    e = !0, n = d;
  } finally {
    try {
      !r && t.return != null && t.return();
    } finally {
      if (e)
        throw n;
    }
  }
  return "en";
};
function Ss() {
  var r = window.document, e = r.createElement("div");
  return e.setAttribute("id", zr), r.body.appendChild(e), e;
}
function Hr() {
  var r = window.document, e = r.getElementById(yn);
  e && (e.className = e.className.replace("fadeIn", "fadeOut"), setTimeout(function() {
    var n = r.getElementById(zr);
    n && r.body.removeChild(n);
  }, 300));
}
function Is(r) {
  return function() {
    Hr(), r && r();
  };
}
function Os(r) {
  return gn.apply(this, arguments);
}
function gn() {
  return gn = po(function(r) {
    var e, n, t, i, c, o;
    return ko(this, function(d) {
      switch (d.label) {
        case 0:
          return e = r.isReady, n = r.cb, t = r.lng, i = Ss(), c = mn(i), [4, e];
        case 1:
          return d.sent(), o = t ?? _s(), c.render(ln.createElement(Lr.Provider, { value: { lng: o } }, ln.createElement("style", { dangerouslySetInnerHTML: { __html: Eo } }), ln.createElement(As, { isReady: e, onClose: Is(n) }))), [2];
      }
    });
  }), gn.apply(this, arguments);
}
function Ms() {
  Hr();
}
var Gr = function(r) {
}, Wr = function() {
};
function Ns(r) {
  var e = r.cb, n = r.lng, t = new Promise(function(i, c) {
    Gr = i, Wr = c;
  });
  Mn() || Os({ isReady: t, cb: e, lng: n });
}
function Rs() {
  Mn() || Ms();
}
function Ts(r) {
  Gr(r);
}
function Ps() {
  console.log("relay failed...."), Wr();
}
var Bs = { open: Ns, close: Rs, ready: Ts, fail: Ps }, re = Bs, js = function() {
  throw new Error(
    "ws does not work in the browser. Browser clients must use the native WebSocket object"
  );
};
const Ds = /* @__PURE__ */ Ir(js);
function Y(r) {
  if (r === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return r;
}
function $s(r, e) {
  if (!(r instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function ur(r, e) {
  for (var n = 0; n < e.length; n++) {
    var t = e[n];
    t.enumerable = t.enumerable || !1, t.configurable = !0, "value" in t && (t.writable = !0), Object.defineProperty(r, t.key, t);
  }
}
function Ls(r, e, n) {
  return e && ur(r.prototype, e), n && ur(r, n), r;
}
function Jt(r) {
  return Jt = Object.setPrototypeOf ? Object.getPrototypeOf : function(e) {
    return e.__proto__ || Object.getPrototypeOf(e);
  }, Jt(r);
}
function zs(r, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function");
  r.prototype = Object.create(e && e.prototype, { constructor: { value: r, writable: !0, configurable: !0 } }), e && bn(r, e);
}
function Fs(r, e) {
  return e && (Pn(e) === "object" || typeof e == "function") ? e : Y(r);
}
function bn(r, e) {
  return bn = Object.setPrototypeOf || function(n, t) {
    return n.__proto__ = t, n;
  }, bn(r, e);
}
function Pn(r) {
  "@swc/helpers - typeof";
  return r && typeof Symbol < "u" && r.constructor === Symbol ? "symbol" : typeof r;
}
function Us() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function Vs(r) {
  var e = Us();
  return function() {
    var t = Jt(r), i;
    if (e) {
      var c = Jt(this).constructor;
      i = Reflect.construct(t, arguments, c);
    } else
      i = t.apply(this, arguments);
    return Fs(this, i);
  };
}
var Hs = Object.defineProperty, Gs = function(r, e, n) {
  return e in r ? Hs(r, e, { enumerable: !0, configurable: !0, writable: !0, value: n }) : r[e] = n;
}, ie = function(r, e, n) {
  return Gs(r, (typeof e > "u" ? "undefined" : Pn(e)) != "symbol" ? e + "" : e, n), n;
}, Qr = (typeof window > "u" ? "undefined" : Pn(window)) < "u" ? window.WebSocket : Ds, Ws = function(r) {
  zs(n, r);
  var e = Vs(n);
  function n(t) {
    $s(this, n);
    var i;
    return i = e.call(this), i.opts = t, ie(Y(i), "qs"), ie(Y(i), "urls", []), ie(Y(i), "url"), ie(Y(i), "socket"), ie(Y(i), "nextSocket"), ie(Y(i), "queue", []), ie(Y(i), "subscriptions", []), ie(Y(i), "retryIndex", 0), i.socket = null, i.nextSocket = null, i.subscriptions = t.subscriptions || [], i.qs = "env=browser&protocol=wc&version=".concat(t.version), i;
  }
  return Ls(n, [{ key: "readyState", get: function() {
    return this.socket ? this.socket.readyState : -1;
  }, set: function(t) {
  } }, { key: "connecting", get: function() {
    return this.readyState === 0;
  }, set: function(t) {
  } }, { key: "connected", get: function() {
    return this.readyState === 1;
  }, set: function(t) {
  } }, { key: "retryFailed", get: function() {
    return this.retryIndex > 0 && this.retryIndex > this.urls.length;
  }, set: function(t) {
  } }, { key: "open", value: function(t) {
    if (!Array.isArray(t) || t.length === 0)
      throw new Error("Missing or invalid WebSocket url");
    this.urls = t, this.retryIndex = 0, this.socketCreate();
  } }, { key: "close", value: function() {
    this._socketClose();
  } }, { key: "send", value: function(t, i, c) {
    if (!i || typeof i != "string")
      throw new Error("Missing or invalid topic field");
    this.socketSend({ topic: i, type: "pub", payload: t, silent: !!c });
  } }, { key: "subscribe", value: function(t) {
    this.socketSend({ topic: t, type: "sub", payload: "", silent: !0 });
  } }, { key: "socketCreate", value: function() {
    var i = this;
    if (!this.nextSocket) {
      var c = this.url || this.getWsUrl();
      if (!c)
        return this.events.emit("error", new Error("Retry limit reached. Can't connect to any url."), c);
      if (this.url = c, this.nextSocket = new Qr(c), !this.nextSocket)
        throw new Error("Failed to create socket");
      this.nextSocket.onmessage = function(o) {
        return i.socketReceive(o);
      }, this.nextSocket.onopen = function() {
        return i.socketOpen();
      }, this.nextSocket.onerror = function(o) {
        return i.socketError(o, c);
      }, this.nextSocket.onclose = function(o) {
        i.nextSocket = null, i.socketCreate();
      };
    }
  } }, { key: "getWsUrl", value: function() {
    return this.retryIndex >= this.urls.length ? "" : "".concat(this.urls[this.retryIndex++], "?").concat(this.qs);
  } }, { key: "socketOpen", value: function() {
    this._socketClose(), this.socket = this.nextSocket, this.nextSocket = null, this.queueSubscriptions(), this.pushQueue(), this.events.emit("open", this.urls[this.retryIndex - 1]);
  } }, { key: "_socketClose", value: function() {
    this.socket && (this.socket.onclose = function() {
    }, this.socket.close(), this.events.emit("close"));
  } }, { key: "socketSend", value: function(t) {
    var i = JSON.stringify(t);
    this.socket && this.socket.readyState === 1 ? this.socket.send(i) : this.setToQueue(t);
  } }, { key: "socketReceive", value: function(t) {
    var i;
    try {
      i = JSON.parse(t.data);
    } catch {
      return;
    }
    this.socketSend({ topic: i.topic, type: "ack", payload: "", silent: !0 }), this.socket && this.socket.readyState === 1 && this.events.emit("message", i);
  } }, { key: "socketError", value: function(t, i) {
    this.events.emit("error", t, i);
  } }, { key: "queueSubscriptions", value: function() {
    var i = this;
    this.subscriptions.forEach(function(c) {
      return i.queue.push({ topic: c, type: "sub", payload: "", silent: !0 });
    }), this.subscriptions = this.opts.subscriptions || [];
  } }, { key: "setToQueue", value: function(t) {
    this.queue.push(t);
  } }, { key: "pushQueue", value: function() {
    var i = this;
    this.queue.forEach(function(c) {
      return i.socketSend(c);
    }), this.queue = [];
  } }]), n;
}(Nn);
function Qs(r) {
  var e = Date.now();
  return new Promise(function(n) {
    try {
      setTimeout(function() {
        n({ ttl: 0, url: r });
      }, 5e3);
      var t = new Qr(r);
      t.onopen = function() {
        t.close(), n({ ttl: Date.now() - e, url: r });
      }, t.onerror = function() {
        n({ ttl: 0, url: r });
      };
    } catch {
      n({ ttl: 0, url: r });
    }
  });
}
function Jr(r) {
  if (r === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return r;
}
function Bn(r, e) {
  if (!(r instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function Zt(r) {
  return Zt = Object.setPrototypeOf ? Object.getPrototypeOf : function(e) {
    return e.__proto__ || Object.getPrototypeOf(e);
  }, Zt(r);
}
function Zr(r, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function");
  r.prototype = Object.create(e && e.prototype, { constructor: { value: r, writable: !0, configurable: !0 } }), e && wn(r, e);
}
function Js(r, e) {
  return e && (qr(e) === "object" || typeof e == "function") ? e : Jr(r);
}
function wn(r, e) {
  return wn = Object.setPrototypeOf || function(n, t) {
    return n.__proto__ = t, n;
  }, wn(r, e);
}
function qr(r) {
  "@swc/helpers - typeof";
  return r && typeof Symbol < "u" && r.constructor === Symbol ? "symbol" : typeof r;
}
function Zs() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function Yr(r) {
  var e = Zs();
  return function() {
    var t = Zt(r), i;
    if (e) {
      var c = Zt(this).constructor;
      i = Reflect.construct(t, arguments, c);
    } else
      i = t.apply(this, arguments);
    return Js(this, i);
  };
}
var qs = Object.defineProperty, Ys = function(r, e, n) {
  return e in r ? qs(r, e, { enumerable: !0, configurable: !0, writable: !0, value: n }) : r[e] = n;
}, Kr = function(r, e, n) {
  return Ys(r, (typeof e > "u" ? "undefined" : qr(e)) != "symbol" ? e + "" : e, n), n;
}, Ks = function r() {
  Bn(this, r), Kr(this, "events");
}, Xs = function(r) {
  Zr(n, r);
  var e = Yr(n);
  function n() {
    return Bn(this, n), e.apply(this, arguments);
  }
  return n;
}(Ks);
(function(r) {
  Zr(n, r);
  var e = Yr(n);
  function n() {
    Bn(this, n);
    var t;
    return t = e.call.apply(e, [this].concat(Array.prototype.slice.call(arguments))), Kr(Jr(t), "connection"), t;
  }
  return n;
})(Xs);
var qt = function(r) {
  return r[r.DisconnectAtWallet = 0] = "DisconnectAtWallet", r[r.DisconnectAtClient = 1] = "DisconnectAtClient", r[r.NetworkError = 2] = "NetworkError", r;
}(qt || {});
const ea = "properties/5.7.0";
globalThis && globalThis.__awaiter;
const Xr = new R(ea);
function j(r, e, n) {
  Object.defineProperty(r, e, {
    enumerable: !0,
    value: n,
    writable: !1
  });
}
function $t(r, e) {
  for (let n = 0; n < 32; n++) {
    if (r[e])
      return r[e];
    if (!r.prototype || typeof r.prototype != "object")
      break;
    r = Object.getPrototypeOf(r.prototype).constructor;
  }
  return null;
}
const ta = { bigint: !0, boolean: !0, function: !0, number: !0, string: !0 };
function ei(r) {
  if (r == null || ta[typeof r])
    return !0;
  if (Array.isArray(r) || typeof r == "object") {
    if (!Object.isFrozen(r))
      return !1;
    const e = Object.keys(r);
    for (let n = 0; n < e.length; n++) {
      let t = null;
      try {
        t = r[e[n]];
      } catch {
        continue;
      }
      if (!ei(t))
        return !1;
    }
    return !0;
  }
  return Xr.throwArgumentError(`Cannot deepCopy ${typeof r}`, "object", r);
}
function na(r) {
  if (ei(r))
    return r;
  if (Array.isArray(r))
    return Object.freeze(r.map((e) => kn(e)));
  if (typeof r == "object") {
    const e = {};
    for (const n in r) {
      const t = r[n];
      t !== void 0 && j(e, n, kn(t));
    }
    return e;
  }
  return Xr.throwArgumentError(`Cannot deepCopy ${typeof r}`, "object", r);
}
function kn(r) {
  return na(r);
}
class sn {
  constructor(e) {
    for (const n in e)
      this[n] = kn(e[n]);
  }
}
const Re = "abi/5.7.0", _ = new R(Re), le = {};
let lr = { calldata: !0, memory: !0, storage: !0 }, ra = { calldata: !0, memory: !0 };
function Lt(r, e) {
  if (r === "bytes" || r === "string") {
    if (lr[e])
      return !0;
  } else if (r === "address") {
    if (e === "payable")
      return !0;
  } else if ((r.indexOf("[") >= 0 || r === "tuple") && ra[e])
    return !0;
  return (lr[e] || e === "payable") && _.throwArgumentError("invalid modifier", "name", e), !1;
}
function ia(r, e) {
  let n = r;
  function t(d) {
    _.throwArgumentError(`unexpected character at position ${d}`, "param", r);
  }
  r = r.replace(/\s/g, " ");
  function i(d) {
    let u = { type: "", name: "", parent: d, state: { allowType: !0 } };
    return e && (u.indexed = !1), u;
  }
  let c = { type: "", name: "", state: { allowType: !0 } }, o = c;
  for (let d = 0; d < r.length; d++) {
    let u = r[d];
    switch (u) {
      case "(":
        o.state.allowType && o.type === "" ? o.type = "tuple" : o.state.allowParams || t(d), o.state.allowType = !1, o.type = he(o.type), o.components = [i(o)], o = o.components[0];
        break;
      case ")":
        delete o.state, o.name === "indexed" && (e || t(d), o.indexed = !0, o.name = ""), Lt(o.type, o.name) && (o.name = ""), o.type = he(o.type);
        let s = o;
        o = o.parent, o || t(d), delete s.parent, o.state.allowParams = !1, o.state.allowName = !0, o.state.allowArray = !0;
        break;
      case ",":
        delete o.state, o.name === "indexed" && (e || t(d), o.indexed = !0, o.name = ""), Lt(o.type, o.name) && (o.name = ""), o.type = he(o.type);
        let l = i(o.parent);
        o.parent.components.push(l), delete o.parent, o = l;
        break;
      case " ":
        o.state.allowType && o.type !== "" && (o.type = he(o.type), delete o.state.allowType, o.state.allowName = !0, o.state.allowParams = !0), o.state.allowName && o.name !== "" && (o.name === "indexed" ? (e || t(d), o.indexed && t(d), o.indexed = !0, o.name = "") : Lt(o.type, o.name) ? o.name = "" : o.state.allowName = !1);
        break;
      case "[":
        o.state.allowArray || t(d), o.type += u, o.state.allowArray = !1, o.state.allowName = !1, o.state.readArray = !0;
        break;
      case "]":
        o.state.readArray || t(d), o.type += u, o.state.readArray = !1, o.state.allowArray = !0, o.state.allowName = !0;
        break;
      default:
        o.state.allowType ? (o.type += u, o.state.allowParams = !0, o.state.allowArray = !0) : o.state.allowName ? (o.name += u, delete o.state.allowArray) : o.state.readArray ? o.type += u : t(d);
    }
  }
  return o.parent && _.throwArgumentError("unexpected eof", "param", r), delete c.state, o.name === "indexed" ? (e || t(n.length - 7), o.indexed && t(n.length - 7), o.indexed = !0, o.name = "") : Lt(o.type, o.name) && (o.name = ""), c.type = he(c.type), c;
}
function Ht(r, e) {
  for (let n in e)
    j(r, n, e[n]);
}
const S = Object.freeze({
  // Bare formatting, as is needed for computing a sighash of an event or function
  sighash: "sighash",
  // Human-Readable with Minimal spacing and without names (compact human-readable)
  minimal: "minimal",
  // Human-Readable with nice spacing, including all names
  full: "full",
  // JSON-format a la Solidity
  json: "json"
}), oa = new RegExp(/^(.*)\[([0-9]*)\]$/);
class B {
  constructor(e, n) {
    e !== le && _.throwError("use fromString", R.errors.UNSUPPORTED_OPERATION, {
      operation: "new ParamType()"
    }), Ht(this, n);
    let t = this.type.match(oa);
    t ? Ht(this, {
      arrayLength: parseInt(t[2] || "-1"),
      arrayChildren: B.fromObject({
        type: t[1],
        components: this.components
      }),
      baseType: "array"
    }) : Ht(this, {
      arrayLength: null,
      arrayChildren: null,
      baseType: this.components != null ? "tuple" : this.type
    }), this._isParamType = !0, Object.freeze(this);
  }
  // Format the parameter fragment
  //   - sighash: "(uint256,address)"
  //   - minimal: "tuple(uint256,address) indexed"
  //   - full:    "tuple(uint256 foo, address bar) indexed baz"
  format(e) {
    if (e || (e = S.sighash), S[e] || _.throwArgumentError("invalid format type", "format", e), e === S.json) {
      let t = {
        type: this.baseType === "tuple" ? "tuple" : this.type,
        name: this.name || void 0
      };
      return typeof this.indexed == "boolean" && (t.indexed = this.indexed), this.components && (t.components = this.components.map((i) => JSON.parse(i.format(e)))), JSON.stringify(t);
    }
    let n = "";
    return this.baseType === "array" ? (n += this.arrayChildren.format(e), n += "[" + (this.arrayLength < 0 ? "" : String(this.arrayLength)) + "]") : this.baseType === "tuple" ? (e !== S.sighash && (n += this.type), n += "(" + this.components.map((t) => t.format(e)).join(e === S.full ? ", " : ",") + ")") : n += this.type, e !== S.sighash && (this.indexed === !0 && (n += " indexed"), e === S.full && this.name && (n += " " + this.name)), n;
  }
  static from(e, n) {
    return typeof e == "string" ? B.fromString(e, n) : B.fromObject(e);
  }
  static fromObject(e) {
    return B.isParamType(e) ? e : new B(le, {
      name: e.name || null,
      type: he(e.type),
      indexed: e.indexed == null ? null : !!e.indexed,
      components: e.components ? e.components.map(B.fromObject) : null
    });
  }
  static fromString(e, n) {
    function t(i) {
      return B.fromObject({
        name: i.name,
        type: i.type,
        indexed: i.indexed,
        components: i.components
      });
    }
    return t(ia(e, !!n));
  }
  static isParamType(e) {
    return !!(e != null && e._isParamType);
  }
}
function Ie(r, e) {
  return aa(r).map((n) => B.fromString(n, e));
}
class X {
  constructor(e, n) {
    e !== le && _.throwError("use a static from method", R.errors.UNSUPPORTED_OPERATION, {
      operation: "new Fragment()"
    }), Ht(this, n), this._isFragment = !0, Object.freeze(this);
  }
  static from(e) {
    return X.isFragment(e) ? e : typeof e == "string" ? X.fromString(e) : X.fromObject(e);
  }
  static fromObject(e) {
    if (X.isFragment(e))
      return e;
    switch (e.type) {
      case "function":
        return J.fromObject(e);
      case "event":
        return K.fromObject(e);
      case "constructor":
        return Q.fromObject(e);
      case "error":
        return oe.fromObject(e);
      case "fallback":
      case "receive":
        return null;
    }
    return _.throwArgumentError("invalid fragment object", "value", e);
  }
  static fromString(e) {
    return e = e.replace(/\s/g, " "), e = e.replace(/\(/g, " (").replace(/\)/g, ") ").replace(/\s+/g, " "), e = e.trim(), e.split(" ")[0] === "event" ? K.fromString(e.substring(5).trim()) : e.split(" ")[0] === "function" ? J.fromString(e.substring(8).trim()) : e.split("(")[0].trim() === "constructor" ? Q.fromString(e.trim()) : e.split(" ")[0] === "error" ? oe.fromString(e.substring(5).trim()) : _.throwArgumentError("unsupported fragment", "value", e);
  }
  static isFragment(e) {
    return !!(e && e._isFragment);
  }
}
class K extends X {
  format(e) {
    if (e || (e = S.sighash), S[e] || _.throwArgumentError("invalid format type", "format", e), e === S.json)
      return JSON.stringify({
        type: "event",
        anonymous: this.anonymous,
        name: this.name,
        inputs: this.inputs.map((t) => JSON.parse(t.format(e)))
      });
    let n = "";
    return e !== S.sighash && (n += "event "), n += this.name + "(" + this.inputs.map((t) => t.format(e)).join(e === S.full ? ", " : ",") + ") ", e !== S.sighash && this.anonymous && (n += "anonymous "), n.trim();
  }
  static from(e) {
    return typeof e == "string" ? K.fromString(e) : K.fromObject(e);
  }
  static fromObject(e) {
    if (K.isEventFragment(e))
      return e;
    e.type !== "event" && _.throwArgumentError("invalid event object", "value", e);
    const n = {
      name: Oe(e.name),
      anonymous: e.anonymous,
      inputs: e.inputs ? e.inputs.map(B.fromObject) : [],
      type: "event"
    };
    return new K(le, n);
  }
  static fromString(e) {
    let n = e.match(Me);
    n || _.throwArgumentError("invalid event string", "value", e);
    let t = !1;
    return n[3].split(" ").forEach((i) => {
      switch (i.trim()) {
        case "anonymous":
          t = !0;
          break;
        case "":
          break;
        default:
          _.warn("unknown modifier: " + i);
      }
    }), K.fromObject({
      name: n[1].trim(),
      anonymous: t,
      inputs: Ie(n[2], !0),
      type: "event"
    });
  }
  static isEventFragment(e) {
    return e && e._isFragment && e.type === "event";
  }
}
function ti(r, e) {
  e.gas = null;
  let n = r.split("@");
  return n.length !== 1 ? (n.length > 2 && _.throwArgumentError("invalid human-readable ABI signature", "value", r), n[1].match(/^[0-9]+$/) || _.throwArgumentError("invalid human-readable ABI signature gas", "value", r), e.gas = G.from(n[1]), n[0]) : r;
}
function ni(r, e) {
  e.constant = !1, e.payable = !1, e.stateMutability = "nonpayable", r.split(" ").forEach((n) => {
    switch (n.trim()) {
      case "constant":
        e.constant = !0;
        break;
      case "payable":
        e.payable = !0, e.stateMutability = "payable";
        break;
      case "nonpayable":
        e.payable = !1, e.stateMutability = "nonpayable";
        break;
      case "pure":
        e.constant = !0, e.stateMutability = "pure";
        break;
      case "view":
        e.constant = !0, e.stateMutability = "view";
        break;
      case "external":
      case "public":
      case "":
        break;
      default:
        console.log("unknown modifier: " + n);
    }
  });
}
function ri(r) {
  let e = {
    constant: !1,
    payable: !0,
    stateMutability: "payable"
  };
  return r.stateMutability != null ? (e.stateMutability = r.stateMutability, e.constant = e.stateMutability === "view" || e.stateMutability === "pure", r.constant != null && !!r.constant !== e.constant && _.throwArgumentError("cannot have constant function with mutability " + e.stateMutability, "value", r), e.payable = e.stateMutability === "payable", r.payable != null && !!r.payable !== e.payable && _.throwArgumentError("cannot have payable function with mutability " + e.stateMutability, "value", r)) : r.payable != null ? (e.payable = !!r.payable, r.constant == null && !e.payable && r.type !== "constructor" && _.throwArgumentError("unable to determine stateMutability", "value", r), e.constant = !!r.constant, e.constant ? e.stateMutability = "view" : e.stateMutability = e.payable ? "payable" : "nonpayable", e.payable && e.constant && _.throwArgumentError("cannot have constant payable function", "value", r)) : r.constant != null ? (e.constant = !!r.constant, e.payable = !e.constant, e.stateMutability = e.constant ? "view" : "payable") : r.type !== "constructor" && _.throwArgumentError("unable to determine stateMutability", "value", r), e;
}
class Q extends X {
  format(e) {
    if (e || (e = S.sighash), S[e] || _.throwArgumentError("invalid format type", "format", e), e === S.json)
      return JSON.stringify({
        type: "constructor",
        stateMutability: this.stateMutability !== "nonpayable" ? this.stateMutability : void 0,
        payable: this.payable,
        gas: this.gas ? this.gas.toNumber() : void 0,
        inputs: this.inputs.map((t) => JSON.parse(t.format(e)))
      });
    e === S.sighash && _.throwError("cannot format a constructor for sighash", R.errors.UNSUPPORTED_OPERATION, {
      operation: "format(sighash)"
    });
    let n = "constructor(" + this.inputs.map((t) => t.format(e)).join(e === S.full ? ", " : ",") + ") ";
    return this.stateMutability && this.stateMutability !== "nonpayable" && (n += this.stateMutability + " "), n.trim();
  }
  static from(e) {
    return typeof e == "string" ? Q.fromString(e) : Q.fromObject(e);
  }
  static fromObject(e) {
    if (Q.isConstructorFragment(e))
      return e;
    e.type !== "constructor" && _.throwArgumentError("invalid constructor object", "value", e);
    let n = ri(e);
    n.constant && _.throwArgumentError("constructor cannot be constant", "value", e);
    const t = {
      name: null,
      type: e.type,
      inputs: e.inputs ? e.inputs.map(B.fromObject) : [],
      payable: n.payable,
      stateMutability: n.stateMutability,
      gas: e.gas ? G.from(e.gas) : null
    };
    return new Q(le, t);
  }
  static fromString(e) {
    let n = { type: "constructor" };
    e = ti(e, n);
    let t = e.match(Me);
    return (!t || t[1].trim() !== "constructor") && _.throwArgumentError("invalid constructor string", "value", e), n.inputs = Ie(t[2].trim(), !1), ni(t[3].trim(), n), Q.fromObject(n);
  }
  static isConstructorFragment(e) {
    return e && e._isFragment && e.type === "constructor";
  }
}
class J extends Q {
  format(e) {
    if (e || (e = S.sighash), S[e] || _.throwArgumentError("invalid format type", "format", e), e === S.json)
      return JSON.stringify({
        type: "function",
        name: this.name,
        constant: this.constant,
        stateMutability: this.stateMutability !== "nonpayable" ? this.stateMutability : void 0,
        payable: this.payable,
        gas: this.gas ? this.gas.toNumber() : void 0,
        inputs: this.inputs.map((t) => JSON.parse(t.format(e))),
        outputs: this.outputs.map((t) => JSON.parse(t.format(e)))
      });
    let n = "";
    return e !== S.sighash && (n += "function "), n += this.name + "(" + this.inputs.map((t) => t.format(e)).join(e === S.full ? ", " : ",") + ") ", e !== S.sighash && (this.stateMutability ? this.stateMutability !== "nonpayable" && (n += this.stateMutability + " ") : this.constant && (n += "view "), this.outputs && this.outputs.length && (n += "returns (" + this.outputs.map((t) => t.format(e)).join(", ") + ") "), this.gas != null && (n += "@" + this.gas.toString() + " ")), n.trim();
  }
  static from(e) {
    return typeof e == "string" ? J.fromString(e) : J.fromObject(e);
  }
  static fromObject(e) {
    if (J.isFunctionFragment(e))
      return e;
    e.type !== "function" && _.throwArgumentError("invalid function object", "value", e);
    let n = ri(e);
    const t = {
      type: e.type,
      name: Oe(e.name),
      constant: n.constant,
      inputs: e.inputs ? e.inputs.map(B.fromObject) : [],
      outputs: e.outputs ? e.outputs.map(B.fromObject) : [],
      payable: n.payable,
      stateMutability: n.stateMutability,
      gas: e.gas ? G.from(e.gas) : null
    };
    return new J(le, t);
  }
  static fromString(e) {
    let n = { type: "function" };
    e = ti(e, n);
    let t = e.split(" returns ");
    t.length > 2 && _.throwArgumentError("invalid function string", "value", e);
    let i = t[0].match(Me);
    if (i || _.throwArgumentError("invalid function signature", "value", e), n.name = i[1].trim(), n.name && Oe(n.name), n.inputs = Ie(i[2], !1), ni(i[3].trim(), n), t.length > 1) {
      let c = t[1].match(Me);
      (c[1].trim() != "" || c[3].trim() != "") && _.throwArgumentError("unexpected tokens", "value", e), n.outputs = Ie(c[2], !1);
    } else
      n.outputs = [];
    return J.fromObject(n);
  }
  static isFunctionFragment(e) {
    return e && e._isFragment && e.type === "function";
  }
}
function dr(r) {
  const e = r.format();
  return (e === "Error(string)" || e === "Panic(uint256)") && _.throwArgumentError(`cannot specify user defined ${e} error`, "fragment", r), r;
}
class oe extends X {
  format(e) {
    if (e || (e = S.sighash), S[e] || _.throwArgumentError("invalid format type", "format", e), e === S.json)
      return JSON.stringify({
        type: "error",
        name: this.name,
        inputs: this.inputs.map((t) => JSON.parse(t.format(e)))
      });
    let n = "";
    return e !== S.sighash && (n += "error "), n += this.name + "(" + this.inputs.map((t) => t.format(e)).join(e === S.full ? ", " : ",") + ") ", n.trim();
  }
  static from(e) {
    return typeof e == "string" ? oe.fromString(e) : oe.fromObject(e);
  }
  static fromObject(e) {
    if (oe.isErrorFragment(e))
      return e;
    e.type !== "error" && _.throwArgumentError("invalid error object", "value", e);
    const n = {
      type: e.type,
      name: Oe(e.name),
      inputs: e.inputs ? e.inputs.map(B.fromObject) : []
    };
    return dr(new oe(le, n));
  }
  static fromString(e) {
    let n = { type: "error" }, t = e.match(Me);
    return t || _.throwArgumentError("invalid error signature", "value", e), n.name = t[1].trim(), n.name && Oe(n.name), n.inputs = Ie(t[2], !1), dr(oe.fromObject(n));
  }
  static isErrorFragment(e) {
    return e && e._isFragment && e.type === "error";
  }
}
function he(r) {
  return r.match(/^uint($|[^1-9])/) ? r = "uint256" + r.substring(4) : r.match(/^int($|[^1-9])/) && (r = "int256" + r.substring(3)), r;
}
const sa = new RegExp("^[a-zA-Z$_][a-zA-Z0-9$_]*$");
function Oe(r) {
  return (!r || !r.match(sa)) && _.throwArgumentError(`invalid identifier "${r}"`, "value", r), r;
}
const Me = new RegExp("^([^)(]*)\\((.*)\\)([^)(]*)$");
function aa(r) {
  r = r.trim();
  let e = [], n = "", t = 0;
  for (let i = 0; i < r.length; i++) {
    let c = r[i];
    c === "," && t === 0 ? (e.push(n), n = "") : (n += c, c === "(" ? t++ : c === ")" && (t--, t === -1 && _.throwArgumentError("unbalanced parenthesis", "value", r)));
  }
  return n && e.push(n), e;
}
const jn = new R(Re);
class ee {
  constructor(e, n, t, i) {
    this.name = e, this.type = n, this.localName = t, this.dynamic = i;
  }
  _throwError(e, n) {
    jn.throwArgumentError(e, this.localName, n);
  }
}
class vn {
  constructor(e) {
    j(this, "wordSize", e || 32), this._data = [], this._dataLength = 0, this._padding = new Uint8Array(e);
  }
  get data() {
    return Ei(this._data);
  }
  get length() {
    return this._dataLength;
  }
  _writeData(e) {
    return this._data.push(e), this._dataLength += e.length, e.length;
  }
  appendWriter(e) {
    return this._writeData(ye(e._data));
  }
  // Arrayish items; padded on the right to wordSize
  writeBytes(e) {
    let n = V(e);
    const t = n.length % this.wordSize;
    return t && (n = ye([n, this._padding.slice(t)])), this._writeData(n);
  }
  _getValue(e) {
    let n = V(G.from(e));
    return n.length > this.wordSize && jn.throwError("value out-of-bounds", R.errors.BUFFER_OVERRUN, {
      length: this.wordSize,
      offset: n.length
    }), n.length % this.wordSize && (n = ye([this._padding.slice(n.length % this.wordSize), n])), n;
  }
  // BigNumberish items; padded on the left to wordSize
  writeValue(e) {
    return this._writeData(this._getValue(e));
  }
  writeUpdatableValue() {
    const e = this._data.length;
    return this._data.push(this._padding), this._dataLength += this.wordSize, (n) => {
      this._data[e] = this._getValue(n);
    };
  }
}
class Yt {
  constructor(e, n, t, i) {
    j(this, "_data", V(e)), j(this, "wordSize", n || 32), j(this, "_coerceFunc", t), j(this, "allowLoose", i), this._offset = 0;
  }
  get data() {
    return z(this._data);
  }
  get consumed() {
    return this._offset;
  }
  // The default Coerce function
  static coerce(e, n) {
    let t = e.match("^u?int([0-9]+)$");
    return t && parseInt(t[1]) <= 48 && (n = n.toNumber()), n;
  }
  coerce(e, n) {
    return this._coerceFunc ? this._coerceFunc(e, n) : Yt.coerce(e, n);
  }
  _peekBytes(e, n, t) {
    let i = Math.ceil(n / this.wordSize) * this.wordSize;
    return this._offset + i > this._data.length && (this.allowLoose && t && this._offset + n <= this._data.length ? i = n : jn.throwError("data out-of-bounds", R.errors.BUFFER_OVERRUN, {
      length: this._data.length,
      offset: this._offset + i
    })), this._data.slice(this._offset, this._offset + i);
  }
  subReader(e) {
    return new Yt(this._data.slice(this._offset + e), this.wordSize, this._coerceFunc, this.allowLoose);
  }
  readBytes(e, n) {
    let t = this._peekBytes(0, e, !!n);
    return this._offset += t.length, t.slice(0, e);
  }
  readValue() {
    return G.from(this.readBytes(this.wordSize));
  }
}
var ii = { exports: {} };
(function(r) {
  (function() {
    var e = "input is invalid type", n = "finalize already called", t = typeof window == "object", i = t ? window : {};
    i.JS_SHA3_NO_WINDOW && (t = !1);
    var c = !t && typeof self == "object", o = !i.JS_SHA3_NO_NODE_JS && typeof Vt == "object" && Vt.versions && Vt.versions.node;
    o ? i = xi : c && (i = self);
    var d = !i.JS_SHA3_NO_COMMON_JS && !0 && r.exports, u = !i.JS_SHA3_NO_ARRAY_BUFFER && typeof ArrayBuffer < "u", s = "0123456789abcdef".split(""), l = [31, 7936, 2031616, 520093696], f = [4, 1024, 262144, 67108864], h = [1, 256, 65536, 16777216], b = [6, 1536, 393216, 100663296], g = [0, 8, 16, 24], I = [
      1,
      0,
      32898,
      0,
      32906,
      2147483648,
      2147516416,
      2147483648,
      32907,
      0,
      2147483649,
      0,
      2147516545,
      2147483648,
      32777,
      2147483648,
      138,
      0,
      136,
      0,
      2147516425,
      0,
      2147483658,
      0,
      2147516555,
      0,
      139,
      2147483648,
      32905,
      2147483648,
      32771,
      2147483648,
      32770,
      2147483648,
      128,
      2147483648,
      32778,
      0,
      2147483658,
      2147483648,
      2147516545,
      2147483648,
      32896,
      2147483648,
      2147483649,
      0,
      2147516424,
      2147483648
    ], A = [224, 256, 384, 512], Z = [128, 256], W = ["hex", "buffer", "arrayBuffer", "array", "digest"], O = {
      128: 168,
      256: 136
    };
    (i.JS_SHA3_NO_NODE_JS || !Array.isArray) && (Array.isArray = function(a) {
      return Object.prototype.toString.call(a) === "[object Array]";
    }), u && (i.JS_SHA3_NO_ARRAY_BUFFER_IS_VIEW || !ArrayBuffer.isView) && (ArrayBuffer.isView = function(a) {
      return typeof a == "object" && a.buffer && a.buffer.constructor === ArrayBuffer;
    });
    for (var D = function(a, p, m) {
      return function(y) {
        return new T(a, p, a).update(y)[m]();
      };
    }, q = function(a, p, m) {
      return function(y, k) {
        return new T(a, p, k).update(y)[m]();
      };
    }, Te = function(a, p, m) {
      return function(y, k, E, x) {
        return te["cshake" + a].update(y, k, E, x)[m]();
      };
    }, Vn = function(a, p, m) {
      return function(y, k, E, x) {
        return te["kmac" + a].update(y, k, E, x)[m]();
      };
    }, Pe = function(a, p, m, y) {
      for (var k = 0; k < W.length; ++k) {
        var E = W[k];
        a[E] = p(m, y, E);
      }
      return a;
    }, Hn = function(a, p) {
      var m = D(a, p, "hex");
      return m.create = function() {
        return new T(a, p, a);
      }, m.update = function(y) {
        return m.create().update(y);
      }, Pe(m, D, a, p);
    }, hi = function(a, p) {
      var m = q(a, p, "hex");
      return m.create = function(y) {
        return new T(a, p, y);
      }, m.update = function(y, k) {
        return m.create(k).update(y);
      }, Pe(m, q, a, p);
    }, pi = function(a, p) {
      var m = O[a], y = Te(a, p, "hex");
      return y.create = function(k, E, x) {
        return !E && !x ? te["shake" + a].create(k) : new T(a, p, k).bytepad([E, x], m);
      }, y.update = function(k, E, x, v) {
        return y.create(E, x, v).update(k);
      }, Pe(y, Te, a, p);
    }, mi = function(a, p) {
      var m = O[a], y = Vn(a, p, "hex");
      return y.create = function(k, E, x) {
        return new cn(a, p, E).bytepad(["KMAC", x], m).bytepad([k], m);
      }, y.update = function(k, E, x, v) {
        return y.create(k, x, v).update(E);
      }, Pe(y, Vn, a, p);
    }, Gn = [
      { name: "keccak", padding: h, bits: A, createMethod: Hn },
      { name: "sha3", padding: b, bits: A, createMethod: Hn },
      { name: "shake", padding: l, bits: Z, createMethod: hi },
      { name: "cshake", padding: f, bits: Z, createMethod: pi },
      { name: "kmac", padding: f, bits: Z, createMethod: mi }
    ], te = {}, ke = [], ne = 0; ne < Gn.length; ++ne)
      for (var de = Gn[ne], Be = de.bits, ve = 0; ve < Be.length; ++ve) {
        var an = de.name + "_" + Be[ve];
        if (ke.push(an), te[an] = de.createMethod(Be[ve], de.padding), de.name !== "sha3") {
          var Wn = de.name + Be[ve];
          ke.push(Wn), te[Wn] = te[an];
        }
      }
    function T(a, p, m) {
      this.blocks = [], this.s = [], this.padding = p, this.outputBits = m, this.reset = !0, this.finalized = !1, this.block = 0, this.start = 0, this.blockCount = 1600 - (a << 1) >> 5, this.byteCount = this.blockCount << 2, this.outputBlocks = m >> 5, this.extraBytes = (m & 31) >> 3;
      for (var y = 0; y < 50; ++y)
        this.s[y] = 0;
    }
    T.prototype.update = function(a) {
      if (this.finalized)
        throw new Error(n);
      var p, m = typeof a;
      if (m !== "string") {
        if (m === "object") {
          if (a === null)
            throw new Error(e);
          if (u && a.constructor === ArrayBuffer)
            a = new Uint8Array(a);
          else if (!Array.isArray(a) && (!u || !ArrayBuffer.isView(a)))
            throw new Error(e);
        } else
          throw new Error(e);
        p = !0;
      }
      for (var y = this.blocks, k = this.byteCount, E = a.length, x = this.blockCount, v = 0, P = this.s, C, N; v < E; ) {
        if (this.reset)
          for (this.reset = !1, y[0] = this.block, C = 1; C < x + 1; ++C)
            y[C] = 0;
        if (p)
          for (C = this.start; v < E && C < k; ++v)
            y[C >> 2] |= a[v] << g[C++ & 3];
        else
          for (C = this.start; v < E && C < k; ++v)
            N = a.charCodeAt(v), N < 128 ? y[C >> 2] |= N << g[C++ & 3] : N < 2048 ? (y[C >> 2] |= (192 | N >> 6) << g[C++ & 3], y[C >> 2] |= (128 | N & 63) << g[C++ & 3]) : N < 55296 || N >= 57344 ? (y[C >> 2] |= (224 | N >> 12) << g[C++ & 3], y[C >> 2] |= (128 | N >> 6 & 63) << g[C++ & 3], y[C >> 2] |= (128 | N & 63) << g[C++ & 3]) : (N = 65536 + ((N & 1023) << 10 | a.charCodeAt(++v) & 1023), y[C >> 2] |= (240 | N >> 18) << g[C++ & 3], y[C >> 2] |= (128 | N >> 12 & 63) << g[C++ & 3], y[C >> 2] |= (128 | N >> 6 & 63) << g[C++ & 3], y[C >> 2] |= (128 | N & 63) << g[C++ & 3]);
        if (this.lastByteIndex = C, C >= k) {
          for (this.start = C - k, this.block = y[x], C = 0; C < x; ++C)
            P[C] ^= y[C];
          Ee(P), this.reset = !0;
        } else
          this.start = C;
      }
      return this;
    }, T.prototype.encode = function(a, p) {
      var m = a & 255, y = 1, k = [m];
      for (a = a >> 8, m = a & 255; m > 0; )
        k.unshift(m), a = a >> 8, m = a & 255, ++y;
      return p ? k.push(y) : k.unshift(y), this.update(k), k.length;
    }, T.prototype.encodeString = function(a) {
      var p, m = typeof a;
      if (m !== "string") {
        if (m === "object") {
          if (a === null)
            throw new Error(e);
          if (u && a.constructor === ArrayBuffer)
            a = new Uint8Array(a);
          else if (!Array.isArray(a) && (!u || !ArrayBuffer.isView(a)))
            throw new Error(e);
        } else
          throw new Error(e);
        p = !0;
      }
      var y = 0, k = a.length;
      if (p)
        y = k;
      else
        for (var E = 0; E < a.length; ++E) {
          var x = a.charCodeAt(E);
          x < 128 ? y += 1 : x < 2048 ? y += 2 : x < 55296 || x >= 57344 ? y += 3 : (x = 65536 + ((x & 1023) << 10 | a.charCodeAt(++E) & 1023), y += 4);
        }
      return y += this.encode(y * 8), this.update(a), y;
    }, T.prototype.bytepad = function(a, p) {
      for (var m = this.encode(p), y = 0; y < a.length; ++y)
        m += this.encodeString(a[y]);
      var k = p - m % p, E = [];
      return E.length = k, this.update(E), this;
    }, T.prototype.finalize = function() {
      if (!this.finalized) {
        this.finalized = !0;
        var a = this.blocks, p = this.lastByteIndex, m = this.blockCount, y = this.s;
        if (a[p >> 2] |= this.padding[p & 3], this.lastByteIndex === this.byteCount)
          for (a[0] = a[m], p = 1; p < m + 1; ++p)
            a[p] = 0;
        for (a[m - 1] |= 2147483648, p = 0; p < m; ++p)
          y[p] ^= a[p];
        Ee(y);
      }
    }, T.prototype.toString = T.prototype.hex = function() {
      this.finalize();
      for (var a = this.blockCount, p = this.s, m = this.outputBlocks, y = this.extraBytes, k = 0, E = 0, x = "", v; E < m; ) {
        for (k = 0; k < a && E < m; ++k, ++E)
          v = p[k], x += s[v >> 4 & 15] + s[v & 15] + s[v >> 12 & 15] + s[v >> 8 & 15] + s[v >> 20 & 15] + s[v >> 16 & 15] + s[v >> 28 & 15] + s[v >> 24 & 15];
        E % a === 0 && (Ee(p), k = 0);
      }
      return y && (v = p[k], x += s[v >> 4 & 15] + s[v & 15], y > 1 && (x += s[v >> 12 & 15] + s[v >> 8 & 15]), y > 2 && (x += s[v >> 20 & 15] + s[v >> 16 & 15])), x;
    }, T.prototype.arrayBuffer = function() {
      this.finalize();
      var a = this.blockCount, p = this.s, m = this.outputBlocks, y = this.extraBytes, k = 0, E = 0, x = this.outputBits >> 3, v;
      y ? v = new ArrayBuffer(m + 1 << 2) : v = new ArrayBuffer(x);
      for (var P = new Uint32Array(v); E < m; ) {
        for (k = 0; k < a && E < m; ++k, ++E)
          P[E] = p[k];
        E % a === 0 && Ee(p);
      }
      return y && (P[k] = p[k], v = v.slice(0, x)), v;
    }, T.prototype.buffer = T.prototype.arrayBuffer, T.prototype.digest = T.prototype.array = function() {
      this.finalize();
      for (var a = this.blockCount, p = this.s, m = this.outputBlocks, y = this.extraBytes, k = 0, E = 0, x = [], v, P; E < m; ) {
        for (k = 0; k < a && E < m; ++k, ++E)
          v = E << 2, P = p[k], x[v] = P & 255, x[v + 1] = P >> 8 & 255, x[v + 2] = P >> 16 & 255, x[v + 3] = P >> 24 & 255;
        E % a === 0 && Ee(p);
      }
      return y && (v = E << 2, P = p[k], x[v] = P & 255, y > 1 && (x[v + 1] = P >> 8 & 255), y > 2 && (x[v + 2] = P >> 16 & 255)), x;
    };
    function cn(a, p, m) {
      T.call(this, a, p, m);
    }
    cn.prototype = new T(), cn.prototype.finalize = function() {
      return this.encode(this.outputBits, !0), T.prototype.finalize.call(this);
    };
    var Ee = function(a) {
      var p, m, y, k, E, x, v, P, C, N, je, De, $e, Le, ze, Fe, Ue, Ve, He, Ge, We, Qe, Je, Ze, qe, Ye, Ke, Xe, et, tt, nt, rt, it, ot, st, at, ct, ut, lt, dt, ft, ht, pt, mt, yt, gt, bt, wt, kt, vt, Et, xt, Ct, At, _t, St, It, Ot, Mt, Nt, Rt, Tt, Pt;
      for (y = 0; y < 48; y += 2)
        k = a[0] ^ a[10] ^ a[20] ^ a[30] ^ a[40], E = a[1] ^ a[11] ^ a[21] ^ a[31] ^ a[41], x = a[2] ^ a[12] ^ a[22] ^ a[32] ^ a[42], v = a[3] ^ a[13] ^ a[23] ^ a[33] ^ a[43], P = a[4] ^ a[14] ^ a[24] ^ a[34] ^ a[44], C = a[5] ^ a[15] ^ a[25] ^ a[35] ^ a[45], N = a[6] ^ a[16] ^ a[26] ^ a[36] ^ a[46], je = a[7] ^ a[17] ^ a[27] ^ a[37] ^ a[47], De = a[8] ^ a[18] ^ a[28] ^ a[38] ^ a[48], $e = a[9] ^ a[19] ^ a[29] ^ a[39] ^ a[49], p = De ^ (x << 1 | v >>> 31), m = $e ^ (v << 1 | x >>> 31), a[0] ^= p, a[1] ^= m, a[10] ^= p, a[11] ^= m, a[20] ^= p, a[21] ^= m, a[30] ^= p, a[31] ^= m, a[40] ^= p, a[41] ^= m, p = k ^ (P << 1 | C >>> 31), m = E ^ (C << 1 | P >>> 31), a[2] ^= p, a[3] ^= m, a[12] ^= p, a[13] ^= m, a[22] ^= p, a[23] ^= m, a[32] ^= p, a[33] ^= m, a[42] ^= p, a[43] ^= m, p = x ^ (N << 1 | je >>> 31), m = v ^ (je << 1 | N >>> 31), a[4] ^= p, a[5] ^= m, a[14] ^= p, a[15] ^= m, a[24] ^= p, a[25] ^= m, a[34] ^= p, a[35] ^= m, a[44] ^= p, a[45] ^= m, p = P ^ (De << 1 | $e >>> 31), m = C ^ ($e << 1 | De >>> 31), a[6] ^= p, a[7] ^= m, a[16] ^= p, a[17] ^= m, a[26] ^= p, a[27] ^= m, a[36] ^= p, a[37] ^= m, a[46] ^= p, a[47] ^= m, p = N ^ (k << 1 | E >>> 31), m = je ^ (E << 1 | k >>> 31), a[8] ^= p, a[9] ^= m, a[18] ^= p, a[19] ^= m, a[28] ^= p, a[29] ^= m, a[38] ^= p, a[39] ^= m, a[48] ^= p, a[49] ^= m, Le = a[0], ze = a[1], gt = a[11] << 4 | a[10] >>> 28, bt = a[10] << 4 | a[11] >>> 28, Xe = a[20] << 3 | a[21] >>> 29, et = a[21] << 3 | a[20] >>> 29, Nt = a[31] << 9 | a[30] >>> 23, Rt = a[30] << 9 | a[31] >>> 23, ht = a[40] << 18 | a[41] >>> 14, pt = a[41] << 18 | a[40] >>> 14, ot = a[2] << 1 | a[3] >>> 31, st = a[3] << 1 | a[2] >>> 31, Fe = a[13] << 12 | a[12] >>> 20, Ue = a[12] << 12 | a[13] >>> 20, wt = a[22] << 10 | a[23] >>> 22, kt = a[23] << 10 | a[22] >>> 22, tt = a[33] << 13 | a[32] >>> 19, nt = a[32] << 13 | a[33] >>> 19, Tt = a[42] << 2 | a[43] >>> 30, Pt = a[43] << 2 | a[42] >>> 30, At = a[5] << 30 | a[4] >>> 2, _t = a[4] << 30 | a[5] >>> 2, at = a[14] << 6 | a[15] >>> 26, ct = a[15] << 6 | a[14] >>> 26, Ve = a[25] << 11 | a[24] >>> 21, He = a[24] << 11 | a[25] >>> 21, vt = a[34] << 15 | a[35] >>> 17, Et = a[35] << 15 | a[34] >>> 17, rt = a[45] << 29 | a[44] >>> 3, it = a[44] << 29 | a[45] >>> 3, Ze = a[6] << 28 | a[7] >>> 4, qe = a[7] << 28 | a[6] >>> 4, St = a[17] << 23 | a[16] >>> 9, It = a[16] << 23 | a[17] >>> 9, ut = a[26] << 25 | a[27] >>> 7, lt = a[27] << 25 | a[26] >>> 7, Ge = a[36] << 21 | a[37] >>> 11, We = a[37] << 21 | a[36] >>> 11, xt = a[47] << 24 | a[46] >>> 8, Ct = a[46] << 24 | a[47] >>> 8, mt = a[8] << 27 | a[9] >>> 5, yt = a[9] << 27 | a[8] >>> 5, Ye = a[18] << 20 | a[19] >>> 12, Ke = a[19] << 20 | a[18] >>> 12, Ot = a[29] << 7 | a[28] >>> 25, Mt = a[28] << 7 | a[29] >>> 25, dt = a[38] << 8 | a[39] >>> 24, ft = a[39] << 8 | a[38] >>> 24, Qe = a[48] << 14 | a[49] >>> 18, Je = a[49] << 14 | a[48] >>> 18, a[0] = Le ^ ~Fe & Ve, a[1] = ze ^ ~Ue & He, a[10] = Ze ^ ~Ye & Xe, a[11] = qe ^ ~Ke & et, a[20] = ot ^ ~at & ut, a[21] = st ^ ~ct & lt, a[30] = mt ^ ~gt & wt, a[31] = yt ^ ~bt & kt, a[40] = At ^ ~St & Ot, a[41] = _t ^ ~It & Mt, a[2] = Fe ^ ~Ve & Ge, a[3] = Ue ^ ~He & We, a[12] = Ye ^ ~Xe & tt, a[13] = Ke ^ ~et & nt, a[22] = at ^ ~ut & dt, a[23] = ct ^ ~lt & ft, a[32] = gt ^ ~wt & vt, a[33] = bt ^ ~kt & Et, a[42] = St ^ ~Ot & Nt, a[43] = It ^ ~Mt & Rt, a[4] = Ve ^ ~Ge & Qe, a[5] = He ^ ~We & Je, a[14] = Xe ^ ~tt & rt, a[15] = et ^ ~nt & it, a[24] = ut ^ ~dt & ht, a[25] = lt ^ ~ft & pt, a[34] = wt ^ ~vt & xt, a[35] = kt ^ ~Et & Ct, a[44] = Ot ^ ~Nt & Tt, a[45] = Mt ^ ~Rt & Pt, a[6] = Ge ^ ~Qe & Le, a[7] = We ^ ~Je & ze, a[16] = tt ^ ~rt & Ze, a[17] = nt ^ ~it & qe, a[26] = dt ^ ~ht & ot, a[27] = ft ^ ~pt & st, a[36] = vt ^ ~xt & mt, a[37] = Et ^ ~Ct & yt, a[46] = Nt ^ ~Tt & At, a[47] = Rt ^ ~Pt & _t, a[8] = Qe ^ ~Le & Fe, a[9] = Je ^ ~ze & Ue, a[18] = rt ^ ~Ze & Ye, a[19] = it ^ ~qe & Ke, a[28] = ht ^ ~ot & at, a[29] = pt ^ ~st & ct, a[38] = xt ^ ~mt & gt, a[39] = Ct ^ ~yt & bt, a[48] = Tt ^ ~At & St, a[49] = Pt ^ ~_t & It, a[0] ^= I[y], a[1] ^= I[y + 1];
    };
    if (d)
      r.exports = te;
    else
      for (ne = 0; ne < ke.length; ++ne)
        i[ke[ne]] = te[ke[ne]];
  })();
})(ii);
var ca = ii.exports;
const ua = /* @__PURE__ */ Ir(ca);
function Kt(r) {
  return "0x" + ua.keccak_256(V(r));
}
const la = "address/5.7.0", Se = new R(la);
function fr(r) {
  Ae(r, 20) || Se.throwArgumentError("invalid address", "address", r), r = r.toLowerCase();
  const e = r.substring(2).split(""), n = new Uint8Array(40);
  for (let i = 0; i < 40; i++)
    n[i] = e[i].charCodeAt(0);
  const t = V(Kt(n));
  for (let i = 0; i < 40; i += 2)
    t[i >> 1] >> 4 >= 8 && (e[i] = e[i].toUpperCase()), (t[i >> 1] & 15) >= 8 && (e[i + 1] = e[i + 1].toUpperCase());
  return "0x" + e.join("");
}
const da = 9007199254740991;
function fa(r) {
  return Math.log10 ? Math.log10(r) : Math.log(r) / Math.LN10;
}
const Dn = {};
for (let r = 0; r < 10; r++)
  Dn[String(r)] = String(r);
for (let r = 0; r < 26; r++)
  Dn[String.fromCharCode(65 + r)] = String(10 + r);
const hr = Math.floor(fa(da));
function ha(r) {
  r = r.toUpperCase(), r = r.substring(4) + r.substring(0, 2) + "00";
  let e = r.split("").map((t) => Dn[t]).join("");
  for (; e.length >= hr; ) {
    let t = e.substring(0, hr);
    e = parseInt(t, 10) % 97 + e.substring(t.length);
  }
  let n = String(98 - parseInt(e, 10) % 97);
  for (; n.length < 2; )
    n = "0" + n;
  return n;
}
function En(r) {
  let e = null;
  if (typeof r != "string" && Se.throwArgumentError("invalid address", "address", r), r.match(/^(0x)?[0-9a-fA-F]{40}$/))
    r.substring(0, 2) !== "0x" && (r = "0x" + r), e = fr(r), r.match(/([A-F].*[a-f])|([a-f].*[A-F])/) && e !== r && Se.throwArgumentError("bad address checksum", "address", r);
  else if (r.match(/^XE[0-9]{2}[0-9A-Za-z]{30,31}$/)) {
    for (r.substring(2, 4) !== ha(r) && Se.throwArgumentError("bad icap checksum", "address", r), e = Ci(r.substring(4)); e.length < 40; )
      e = "0" + e;
    e = fr("0x" + e);
  } else
    Se.throwArgumentError("invalid address", "address", r);
  return e;
}
class pa extends ee {
  constructor(e) {
    super("address", "address", e, !1);
  }
  defaultValue() {
    return "0x0000000000000000000000000000000000000000";
  }
  encode(e, n) {
    try {
      n = En(n);
    } catch (t) {
      this._throwError(t.message, n);
    }
    return e.writeValue(n);
  }
  decode(e) {
    return En(Or(e.readValue().toHexString(), 20));
  }
}
class ma extends ee {
  constructor(e) {
    super(e.name, e.type, void 0, e.dynamic), this.coder = e;
  }
  defaultValue() {
    return this.coder.defaultValue();
  }
  encode(e, n) {
    return this.coder.encode(e, n);
  }
  decode(e) {
    return this.coder.decode(e);
  }
}
const me = new R(Re);
function oi(r, e, n) {
  let t = null;
  if (Array.isArray(n))
    t = n;
  else if (n && typeof n == "object") {
    let u = {};
    t = e.map((s) => {
      const l = s.localName;
      return l || me.throwError("cannot encode object for signature with missing names", R.errors.INVALID_ARGUMENT, {
        argument: "values",
        coder: s,
        value: n
      }), u[l] && me.throwError("cannot encode object for signature with duplicate names", R.errors.INVALID_ARGUMENT, {
        argument: "values",
        coder: s,
        value: n
      }), u[l] = !0, n[l];
    });
  } else
    me.throwArgumentError("invalid tuple value", "tuple", n);
  e.length !== t.length && me.throwArgumentError("types/value length mismatch", "tuple", n);
  let i = new vn(r.wordSize), c = new vn(r.wordSize), o = [];
  e.forEach((u, s) => {
    let l = t[s];
    if (u.dynamic) {
      let f = c.length;
      u.encode(c, l);
      let h = i.writeUpdatableValue();
      o.push((b) => {
        h(b + f);
      });
    } else
      u.encode(i, l);
  }), o.forEach((u) => {
    u(i.length);
  });
  let d = r.appendWriter(i);
  return d += r.appendWriter(c), d;
}
function si(r, e) {
  let n = [], t = r.subReader(0);
  e.forEach((c) => {
    let o = null;
    if (c.dynamic) {
      let d = r.readValue(), u = t.subReader(d.toNumber());
      try {
        o = c.decode(u);
      } catch (s) {
        if (s.code === R.errors.BUFFER_OVERRUN)
          throw s;
        o = s, o.baseType = c.name, o.name = c.localName, o.type = c.type;
      }
    } else
      try {
        o = c.decode(r);
      } catch (d) {
        if (d.code === R.errors.BUFFER_OVERRUN)
          throw d;
        o = d, o.baseType = c.name, o.name = c.localName, o.type = c.type;
      }
    o != null && n.push(o);
  });
  const i = e.reduce((c, o) => {
    const d = o.localName;
    return d && (c[d] || (c[d] = 0), c[d]++), c;
  }, {});
  e.forEach((c, o) => {
    let d = c.localName;
    if (!d || i[d] !== 1 || (d === "length" && (d = "_length"), n[d] != null))
      return;
    const u = n[o];
    u instanceof Error ? Object.defineProperty(n, d, {
      enumerable: !0,
      get: () => {
        throw u;
      }
    }) : n[d] = u;
  });
  for (let c = 0; c < n.length; c++) {
    const o = n[c];
    o instanceof Error && Object.defineProperty(n, c, {
      enumerable: !0,
      get: () => {
        throw o;
      }
    });
  }
  return Object.freeze(n);
}
class ya extends ee {
  constructor(e, n, t) {
    const i = e.type + "[" + (n >= 0 ? n : "") + "]", c = n === -1 || e.dynamic;
    super("array", i, t, c), this.coder = e, this.length = n;
  }
  defaultValue() {
    const e = this.coder.defaultValue(), n = [];
    for (let t = 0; t < this.length; t++)
      n.push(e);
    return n;
  }
  encode(e, n) {
    Array.isArray(n) || this._throwError("expected array value", n);
    let t = this.length;
    t === -1 && (t = n.length, e.writeValue(n.length)), me.checkArgumentCount(n.length, t, "coder array" + (this.localName ? " " + this.localName : ""));
    let i = [];
    for (let c = 0; c < n.length; c++)
      i.push(this.coder);
    return oi(e, i, n);
  }
  decode(e) {
    let n = this.length;
    n === -1 && (n = e.readValue().toNumber(), n * 32 > e._data.length && me.throwError("insufficient data length", R.errors.BUFFER_OVERRUN, {
      length: e._data.length,
      count: n
    }));
    let t = [];
    for (let i = 0; i < n; i++)
      t.push(new ma(this.coder));
    return e.coerce(this.name, si(e, t));
  }
}
class ga extends ee {
  constructor(e) {
    super("bool", "bool", e, !1);
  }
  defaultValue() {
    return !1;
  }
  encode(e, n) {
    return e.writeValue(n ? 1 : 0);
  }
  decode(e) {
    return e.coerce(this.type, !e.readValue().isZero());
  }
}
class ai extends ee {
  constructor(e, n) {
    super(e, e, n, !0);
  }
  defaultValue() {
    return "0x";
  }
  encode(e, n) {
    n = V(n);
    let t = e.writeValue(n.length);
    return t += e.writeBytes(n), t;
  }
  decode(e) {
    return e.readBytes(e.readValue().toNumber(), !0);
  }
}
class ba extends ai {
  constructor(e) {
    super("bytes", e);
  }
  decode(e) {
    return e.coerce(this.name, z(super.decode(e)));
  }
}
class wa extends ee {
  constructor(e, n) {
    let t = "bytes" + String(e);
    super(t, t, n, !1), this.size = e;
  }
  defaultValue() {
    return "0x0000000000000000000000000000000000000000000000000000000000000000".substring(0, 2 + this.size * 2);
  }
  encode(e, n) {
    let t = V(n);
    return t.length !== this.size && this._throwError("incorrect data length", n), e.writeBytes(t);
  }
  decode(e) {
    return e.coerce(this.name, z(e.readBytes(this.size)));
  }
}
class ka extends ee {
  constructor(e) {
    super("null", "", e, !1);
  }
  defaultValue() {
    return null;
  }
  encode(e, n) {
    return n != null && this._throwError("not null", n), e.writeBytes([]);
  }
  decode(e) {
    return e.readBytes(0), e.coerce(this.name, null);
  }
}
const va = /* @__PURE__ */ G.from(-1), Ea = /* @__PURE__ */ G.from(0), xa = /* @__PURE__ */ G.from(1), Ca = /* @__PURE__ */ G.from("0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff");
class Aa extends ee {
  constructor(e, n, t) {
    const i = (n ? "int" : "uint") + e * 8;
    super(i, i, t, !1), this.size = e, this.signed = n;
  }
  defaultValue() {
    return 0;
  }
  encode(e, n) {
    let t = G.from(n), i = Ca.mask(e.wordSize * 8);
    if (this.signed) {
      let c = i.mask(this.size * 8 - 1);
      (t.gt(c) || t.lt(c.add(xa).mul(va))) && this._throwError("value out-of-bounds", n);
    } else
      (t.lt(Ea) || t.gt(i.mask(this.size * 8))) && this._throwError("value out-of-bounds", n);
    return t = t.toTwos(this.size * 8).mask(this.size * 8), this.signed && (t = t.fromTwos(this.size * 8).toTwos(8 * e.wordSize)), e.writeValue(t);
  }
  decode(e) {
    let n = e.readValue().mask(this.size * 8);
    return this.signed && (n = n.fromTwos(this.size * 8)), e.coerce(this.name, n);
  }
}
const _a = "strings/5.7.0", ci = new R(_a);
var Xt;
(function(r) {
  r.current = "", r.NFC = "NFC", r.NFD = "NFD", r.NFKC = "NFKC", r.NFKD = "NFKD";
})(Xt || (Xt = {}));
var U;
(function(r) {
  r.UNEXPECTED_CONTINUE = "unexpected continuation byte", r.BAD_PREFIX = "bad codepoint prefix", r.OVERRUN = "string overrun", r.MISSING_CONTINUE = "missing continuation byte", r.OUT_OF_RANGE = "out of UTF-8 range", r.UTF16_SURROGATE = "UTF-16 surrogate", r.OVERLONG = "overlong representation";
})(U || (U = {}));
function Sa(r, e, n, t, i) {
  return ci.throwArgumentError(`invalid codepoint at offset ${e}; ${r}`, "bytes", n);
}
function ui(r, e, n, t, i) {
  if (r === U.BAD_PREFIX || r === U.UNEXPECTED_CONTINUE) {
    let c = 0;
    for (let o = e + 1; o < n.length && n[o] >> 6 === 2; o++)
      c++;
    return c;
  }
  return r === U.OVERRUN ? n.length - e - 1 : 0;
}
function Ia(r, e, n, t, i) {
  return r === U.OVERLONG ? (t.push(i), 0) : (t.push(65533), ui(r, e, n));
}
const Oa = Object.freeze({
  error: Sa,
  ignore: ui,
  replace: Ia
});
function Ma(r, e) {
  e == null && (e = Oa.error), r = V(r);
  const n = [];
  let t = 0;
  for (; t < r.length; ) {
    const i = r[t++];
    if (!(i >> 7)) {
      n.push(i);
      continue;
    }
    let c = null, o = null;
    if ((i & 224) === 192)
      c = 1, o = 127;
    else if ((i & 240) === 224)
      c = 2, o = 2047;
    else if ((i & 248) === 240)
      c = 3, o = 65535;
    else {
      (i & 192) === 128 ? t += e(U.UNEXPECTED_CONTINUE, t - 1, r, n) : t += e(U.BAD_PREFIX, t - 1, r, n);
      continue;
    }
    if (t - 1 + c >= r.length) {
      t += e(U.OVERRUN, t - 1, r, n);
      continue;
    }
    let d = i & (1 << 8 - c - 1) - 1;
    for (let u = 0; u < c; u++) {
      let s = r[t];
      if ((s & 192) != 128) {
        t += e(U.MISSING_CONTINUE, t, r, n), d = null;
        break;
      }
      d = d << 6 | s & 63, t++;
    }
    if (d !== null) {
      if (d > 1114111) {
        t += e(U.OUT_OF_RANGE, t - 1 - c, r, n, d);
        continue;
      }
      if (d >= 55296 && d <= 57343) {
        t += e(U.UTF16_SURROGATE, t - 1 - c, r, n, d);
        continue;
      }
      if (d <= o) {
        t += e(U.OVERLONG, t - 1 - c, r, n, d);
        continue;
      }
      n.push(d);
    }
  }
  return n;
}
function li(r, e = Xt.current) {
  e != Xt.current && (ci.checkNormalize(), r = r.normalize(e));
  let n = [];
  for (let t = 0; t < r.length; t++) {
    const i = r.charCodeAt(t);
    if (i < 128)
      n.push(i);
    else if (i < 2048)
      n.push(i >> 6 | 192), n.push(i & 63 | 128);
    else if ((i & 64512) == 55296) {
      t++;
      const c = r.charCodeAt(t);
      if (t >= r.length || (c & 64512) !== 56320)
        throw new Error("invalid utf-8 string");
      const o = 65536 + ((i & 1023) << 10) + (c & 1023);
      n.push(o >> 18 | 240), n.push(o >> 12 & 63 | 128), n.push(o >> 6 & 63 | 128), n.push(o & 63 | 128);
    } else
      n.push(i >> 12 | 224), n.push(i >> 6 & 63 | 128), n.push(i & 63 | 128);
  }
  return V(n);
}
function Na(r) {
  return r.map((e) => e <= 65535 ? String.fromCharCode(e) : (e -= 65536, String.fromCharCode((e >> 10 & 1023) + 55296, (e & 1023) + 56320))).join("");
}
function Ra(r, e) {
  return Na(Ma(r, e));
}
class Ta extends ai {
  constructor(e) {
    super("string", e);
  }
  defaultValue() {
    return "";
  }
  encode(e, n) {
    return super.encode(e, li(n));
  }
  decode(e) {
    return Ra(super.decode(e));
  }
}
class zt extends ee {
  constructor(e, n) {
    let t = !1;
    const i = [];
    e.forEach((o) => {
      o.dynamic && (t = !0), i.push(o.type);
    });
    const c = "tuple(" + i.join(",") + ")";
    super("tuple", c, n, t), this.coders = e;
  }
  defaultValue() {
    const e = [];
    this.coders.forEach((t) => {
      e.push(t.defaultValue());
    });
    const n = this.coders.reduce((t, i) => {
      const c = i.localName;
      return c && (t[c] || (t[c] = 0), t[c]++), t;
    }, {});
    return this.coders.forEach((t, i) => {
      let c = t.localName;
      !c || n[c] !== 1 || (c === "length" && (c = "_length"), e[c] == null && (e[c] = e[i]));
    }), Object.freeze(e);
  }
  encode(e, n) {
    return oi(e, this.coders, n);
  }
  decode(e) {
    return e.coerce(this.name, si(e, this.coders));
  }
}
const Ft = new R(Re), Pa = new RegExp(/^bytes([0-9]*)$/), Ba = new RegExp(/^(u?int)([0-9]*)$/);
class ja {
  constructor(e) {
    j(this, "coerceFunc", e || null);
  }
  _getCoder(e) {
    switch (e.baseType) {
      case "address":
        return new pa(e.name);
      case "bool":
        return new ga(e.name);
      case "string":
        return new Ta(e.name);
      case "bytes":
        return new ba(e.name);
      case "array":
        return new ya(this._getCoder(e.arrayChildren), e.arrayLength, e.name);
      case "tuple":
        return new zt((e.components || []).map((t) => this._getCoder(t)), e.name);
      case "":
        return new ka(e.name);
    }
    let n = e.type.match(Ba);
    if (n) {
      let t = parseInt(n[2] || "256");
      return (t === 0 || t > 256 || t % 8 !== 0) && Ft.throwArgumentError("invalid " + n[1] + " bit length", "param", e), new Aa(t / 8, n[1] === "int", e.name);
    }
    if (n = e.type.match(Pa), n) {
      let t = parseInt(n[1]);
      return (t === 0 || t > 32) && Ft.throwArgumentError("invalid bytes length", "param", e), new wa(t, e.name);
    }
    return Ft.throwArgumentError("invalid type", "type", e.type);
  }
  _getWordSize() {
    return 32;
  }
  _getReader(e, n) {
    return new Yt(e, this._getWordSize(), this.coerceFunc, n);
  }
  _getWriter() {
    return new vn(this._getWordSize());
  }
  getDefaultValue(e) {
    const n = e.map((i) => this._getCoder(B.from(i)));
    return new zt(n, "_").defaultValue();
  }
  encode(e, n) {
    e.length !== n.length && Ft.throwError("types/values length mismatch", R.errors.INVALID_ARGUMENT, {
      count: { types: e.length, values: n.length },
      value: { types: e, values: n }
    });
    const t = e.map((o) => this._getCoder(B.from(o))), i = new zt(t, "_"), c = this._getWriter();
    return i.encode(c, n), c.data;
  }
  decode(e, n, t) {
    const i = e.map((o) => this._getCoder(B.from(o)));
    return new zt(i, "_").decode(this._getReader(V(n), t));
  }
}
const Da = new ja();
function Ut(r) {
  return Kt(li(r));
}
const M = new R(Re);
class $a extends sn {
}
class La extends sn {
}
class za extends sn {
}
class pr extends sn {
  static isIndexed(e) {
    return !!(e && e._isIndexed);
  }
}
const Fa = {
  "0x08c379a0": { signature: "Error(string)", name: "Error", inputs: ["string"], reason: !0 },
  "0x4e487b71": { signature: "Panic(uint256)", name: "Panic", inputs: ["uint256"] }
};
function mr(r, e) {
  const n = new Error(`deferred error during ABI decoding triggered accessing ${r}`);
  return n.error = e, n;
}
class Ua {
  constructor(e) {
    let n = [];
    typeof e == "string" ? n = JSON.parse(e) : n = e, j(this, "fragments", n.map((t) => X.from(t)).filter((t) => t != null)), j(this, "_abiCoder", $t(new.target, "getAbiCoder")()), j(this, "functions", {}), j(this, "errors", {}), j(this, "events", {}), j(this, "structs", {}), this.fragments.forEach((t) => {
      let i = null;
      switch (t.type) {
        case "constructor":
          if (this.deploy) {
            M.warn("duplicate definition - constructor");
            return;
          }
          j(this, "deploy", t);
          return;
        case "function":
          i = this.functions;
          break;
        case "event":
          i = this.events;
          break;
        case "error":
          i = this.errors;
          break;
        default:
          return;
      }
      let c = t.format();
      if (i[c]) {
        M.warn("duplicate definition - " + c);
        return;
      }
      i[c] = t;
    }), this.deploy || j(this, "deploy", Q.from({
      payable: !1,
      type: "constructor"
    })), j(this, "_isInterface", !0);
  }
  format(e) {
    e || (e = S.full), e === S.sighash && M.throwArgumentError("interface does not support formatting sighash", "format", e);
    const n = this.fragments.map((t) => t.format(e));
    return e === S.json ? JSON.stringify(n.map((t) => JSON.parse(t))) : n;
  }
  // Sub-classes can override these to handle other blockchains
  static getAbiCoder() {
    return Da;
  }
  static getAddress(e) {
    return En(e);
  }
  static getSighash(e) {
    return Ai(Ut(e.format()), 0, 4);
  }
  static getEventTopic(e) {
    return Ut(e.format());
  }
  // Find a function definition by any means necessary (unless it is ambiguous)
  getFunction(e) {
    if (Ae(e)) {
      for (const t in this.functions)
        if (e === this.getSighash(t))
          return this.functions[t];
      M.throwArgumentError("no matching function", "sighash", e);
    }
    if (e.indexOf("(") === -1) {
      const t = e.trim(), i = Object.keys(this.functions).filter((c) => c.split(
        "("
        /* fix:) */
      )[0] === t);
      return i.length === 0 ? M.throwArgumentError("no matching function", "name", t) : i.length > 1 && M.throwArgumentError("multiple matching functions", "name", t), this.functions[i[0]];
    }
    const n = this.functions[J.fromString(e).format()];
    return n || M.throwArgumentError("no matching function", "signature", e), n;
  }
  // Find an event definition by any means necessary (unless it is ambiguous)
  getEvent(e) {
    if (Ae(e)) {
      const t = e.toLowerCase();
      for (const i in this.events)
        if (t === this.getEventTopic(i))
          return this.events[i];
      M.throwArgumentError("no matching event", "topichash", t);
    }
    if (e.indexOf("(") === -1) {
      const t = e.trim(), i = Object.keys(this.events).filter((c) => c.split(
        "("
        /* fix:) */
      )[0] === t);
      return i.length === 0 ? M.throwArgumentError("no matching event", "name", t) : i.length > 1 && M.throwArgumentError("multiple matching events", "name", t), this.events[i[0]];
    }
    const n = this.events[K.fromString(e).format()];
    return n || M.throwArgumentError("no matching event", "signature", e), n;
  }
  // Find a function definition by any means necessary (unless it is ambiguous)
  getError(e) {
    if (Ae(e)) {
      const t = $t(this.constructor, "getSighash");
      for (const i in this.errors) {
        const c = this.errors[i];
        if (e === t(c))
          return this.errors[i];
      }
      M.throwArgumentError("no matching error", "sighash", e);
    }
    if (e.indexOf("(") === -1) {
      const t = e.trim(), i = Object.keys(this.errors).filter((c) => c.split(
        "("
        /* fix:) */
      )[0] === t);
      return i.length === 0 ? M.throwArgumentError("no matching error", "name", t) : i.length > 1 && M.throwArgumentError("multiple matching errors", "name", t), this.errors[i[0]];
    }
    const n = this.errors[J.fromString(e).format()];
    return n || M.throwArgumentError("no matching error", "signature", e), n;
  }
  // Get the sighash (the bytes4 selector) used by Solidity to identify a function
  getSighash(e) {
    if (typeof e == "string")
      try {
        e = this.getFunction(e);
      } catch (n) {
        try {
          e = this.getError(e);
        } catch {
          throw n;
        }
      }
    return $t(this.constructor, "getSighash")(e);
  }
  // Get the topic (the bytes32 hash) used by Solidity to identify an event
  getEventTopic(e) {
    return typeof e == "string" && (e = this.getEvent(e)), $t(this.constructor, "getEventTopic")(e);
  }
  _decodeParams(e, n) {
    return this._abiCoder.decode(e, n);
  }
  _encodeParams(e, n) {
    return this._abiCoder.encode(e, n);
  }
  encodeDeploy(e) {
    return this._encodeParams(this.deploy.inputs, e || []);
  }
  decodeErrorResult(e, n) {
    typeof e == "string" && (e = this.getError(e));
    const t = V(n);
    return z(t.slice(0, 4)) !== this.getSighash(e) && M.throwArgumentError(`data signature does not match error ${e.name}.`, "data", z(t)), this._decodeParams(e.inputs, t.slice(4));
  }
  encodeErrorResult(e, n) {
    return typeof e == "string" && (e = this.getError(e)), z(ye([
      this.getSighash(e),
      this._encodeParams(e.inputs, n || [])
    ]));
  }
  // Decode the data for a function call (e.g. tx.data)
  decodeFunctionData(e, n) {
    typeof e == "string" && (e = this.getFunction(e));
    const t = V(n);
    return z(t.slice(0, 4)) !== this.getSighash(e) && M.throwArgumentError(`data signature does not match function ${e.name}.`, "data", z(t)), this._decodeParams(e.inputs, t.slice(4));
  }
  // Encode the data for a function call (e.g. tx.data)
  encodeFunctionData(e, n) {
    return typeof e == "string" && (e = this.getFunction(e)), z(ye([
      this.getSighash(e),
      this._encodeParams(e.inputs, n || [])
    ]));
  }
  // Decode the result from a function call (e.g. from eth_call)
  decodeFunctionResult(e, n) {
    typeof e == "string" && (e = this.getFunction(e));
    let t = V(n), i = null, c = "", o = null, d = null, u = null;
    switch (t.length % this._abiCoder._getWordSize()) {
      case 0:
        try {
          return this._abiCoder.decode(e.outputs, t);
        } catch {
        }
        break;
      case 4: {
        const s = z(t.slice(0, 4)), l = Fa[s];
        if (l)
          o = this._abiCoder.decode(l.inputs, t.slice(4)), d = l.name, u = l.signature, l.reason && (i = o[0]), d === "Error" ? c = `; VM Exception while processing transaction: reverted with reason string ${JSON.stringify(o[0])}` : d === "Panic" && (c = `; VM Exception while processing transaction: reverted with panic code ${o[0]}`);
        else
          try {
            const f = this.getError(s);
            o = this._abiCoder.decode(f.inputs, t.slice(4)), d = f.name, u = f.format();
          } catch {
          }
        break;
      }
    }
    return M.throwError("call revert exception" + c, R.errors.CALL_EXCEPTION, {
      method: e.format(),
      data: z(n),
      errorArgs: o,
      errorName: d,
      errorSignature: u,
      reason: i
    });
  }
  // Encode the result for a function call (e.g. for eth_call)
  encodeFunctionResult(e, n) {
    return typeof e == "string" && (e = this.getFunction(e)), z(this._abiCoder.encode(e.outputs, n || []));
  }
  // Create the filter for the event with search criteria (e.g. for eth_filterLog)
  encodeFilterTopics(e, n) {
    typeof e == "string" && (e = this.getEvent(e)), n.length > e.inputs.length && M.throwError("too many arguments for " + e.format(), R.errors.UNEXPECTED_ARGUMENT, {
      argument: "values",
      value: n
    });
    let t = [];
    e.anonymous || t.push(this.getEventTopic(e));
    const i = (c, o) => c.type === "string" ? Ut(o) : c.type === "bytes" ? Kt(z(o)) : (c.type === "bool" && typeof o == "boolean" && (o = o ? "0x01" : "0x00"), c.type.match(/^u?int/) && (o = G.from(o).toHexString()), c.type === "address" && this._abiCoder.encode(["address"], [o]), Or(z(o), 32));
    for (n.forEach((c, o) => {
      let d = e.inputs[o];
      if (!d.indexed) {
        c != null && M.throwArgumentError("cannot filter non-indexed parameters; must be null", "contract." + d.name, c);
        return;
      }
      c == null ? t.push(null) : d.baseType === "array" || d.baseType === "tuple" ? M.throwArgumentError("filtering with tuples or arrays not supported", "contract." + d.name, c) : Array.isArray(c) ? t.push(c.map((u) => i(d, u))) : t.push(i(d, c));
    }); t.length && t[t.length - 1] === null; )
      t.pop();
    return t;
  }
  encodeEventLog(e, n) {
    typeof e == "string" && (e = this.getEvent(e));
    const t = [], i = [], c = [];
    return e.anonymous || t.push(this.getEventTopic(e)), n.length !== e.inputs.length && M.throwArgumentError("event arguments/values mismatch", "values", n), e.inputs.forEach((o, d) => {
      const u = n[d];
      if (o.indexed)
        if (o.type === "string")
          t.push(Ut(u));
        else if (o.type === "bytes")
          t.push(Kt(u));
        else {
          if (o.baseType === "tuple" || o.baseType === "array")
            throw new Error("not implemented");
          t.push(this._abiCoder.encode([o.type], [u]));
        }
      else
        i.push(o), c.push(u);
    }), {
      data: this._abiCoder.encode(i, c),
      topics: t
    };
  }
  // Decode a filter for the event and the search criteria
  decodeEventLog(e, n, t) {
    if (typeof e == "string" && (e = this.getEvent(e)), t != null && !e.anonymous) {
      let h = this.getEventTopic(e);
      (!Ae(t[0], 32) || t[0].toLowerCase() !== h) && M.throwError("fragment/topic mismatch", R.errors.INVALID_ARGUMENT, { argument: "topics[0]", expected: h, value: t[0] }), t = t.slice(1);
    }
    let i = [], c = [], o = [];
    e.inputs.forEach((h, b) => {
      h.indexed ? h.type === "string" || h.type === "bytes" || h.baseType === "tuple" || h.baseType === "array" ? (i.push(B.fromObject({ type: "bytes32", name: h.name })), o.push(!0)) : (i.push(h), o.push(!1)) : (c.push(h), o.push(!1));
    });
    let d = t != null ? this._abiCoder.decode(i, ye(t)) : null, u = this._abiCoder.decode(c, n, !0), s = [], l = 0, f = 0;
    e.inputs.forEach((h, b) => {
      if (h.indexed)
        if (d == null)
          s[b] = new pr({ _isIndexed: !0, hash: null });
        else if (o[b])
          s[b] = new pr({ _isIndexed: !0, hash: d[f++] });
        else
          try {
            s[b] = d[f++];
          } catch (g) {
            s[b] = g;
          }
      else
        try {
          s[b] = u[l++];
        } catch (g) {
          s[b] = g;
        }
      if (h.name && s[h.name] == null) {
        const g = s[b];
        g instanceof Error ? Object.defineProperty(s, h.name, {
          enumerable: !0,
          get: () => {
            throw mr(`property ${JSON.stringify(h.name)}`, g);
          }
        }) : s[h.name] = g;
      }
    });
    for (let h = 0; h < s.length; h++) {
      const b = s[h];
      b instanceof Error && Object.defineProperty(s, h, {
        enumerable: !0,
        get: () => {
          throw mr(`index ${h}`, b);
        }
      });
    }
    return Object.freeze(s);
  }
  // Given a transaction, find the matching function fragment (if any) and
  // determine all its properties and call parameters
  parseTransaction(e) {
    let n = this.getFunction(e.data.substring(0, 10).toLowerCase());
    return n ? new La({
      args: this._abiCoder.decode(n.inputs, "0x" + e.data.substring(10)),
      functionFragment: n,
      name: n.name,
      signature: n.format(),
      sighash: this.getSighash(n),
      value: G.from(e.value || "0")
    }) : null;
  }
  // @TODO
  //parseCallResult(data: BytesLike): ??
  // Given an event log, find the matching event fragment (if any) and
  // determine all its properties and values
  parseLog(e) {
    let n = this.getEvent(e.topics[0]);
    return !n || n.anonymous ? null : new $a({
      eventFragment: n,
      name: n.name,
      signature: n.format(),
      topic: this.getEventTopic(n),
      args: this.decodeEventLog(n, e.data, e.topics)
    });
  }
  parseError(e) {
    const n = z(e);
    let t = this.getError(n.substring(0, 10).toLowerCase());
    return t ? new za({
      args: this._abiCoder.decode(t.inputs, "0x" + n.substring(10)),
      errorFragment: t,
      name: t.name,
      signature: t.format(),
      sighash: this.getSighash(t)
    }) : null;
  }
  /*
  static from(value: Array<Fragment | string | JsonAbi> | string | Interface) {
      if (Interface.isInterface(value)) {
          return value;
      }
      if (typeof(value) === "string") {
          return new Interface(JSON.parse(value));
      }
      return new Interface(value);
  }
  */
  static isInterface(e) {
    return !!(e && e._isInterface);
  }
}
function $(r) {
  if (r === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return r;
}
function yr(r, e, n, t, i, c, o) {
  try {
    var d = r[c](o), u = d.value;
  } catch (s) {
    n(s);
    return;
  }
  d.done ? e(u) : Promise.resolve(u).then(t, i);
}
function ge(r) {
  return function() {
    var e = this, n = arguments;
    return new Promise(function(t, i) {
      var c = r.apply(e, n);
      function o(u) {
        yr(c, t, i, o, d, "next", u);
      }
      function d(u) {
        yr(c, t, i, o, d, "throw", u);
      }
      o(void 0);
    });
  };
}
function $n(r, e) {
  if (!(r instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function gr(r, e) {
  for (var n = 0; n < e.length; n++) {
    var t = e[n];
    t.enumerable = t.enumerable || !1, t.configurable = !0, "value" in t && (t.writable = !0), Object.defineProperty(r, t.key, t);
  }
}
function Ln(r, e, n) {
  return e && gr(r.prototype, e), n && gr(r, n), r;
}
function en(r) {
  return en = Object.setPrototypeOf ? Object.getPrototypeOf : function(e) {
    return e.__proto__ || Object.getPrototypeOf(e);
  }, en(r);
}
function zn(r, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function");
  r.prototype = Object.create(e && e.prototype, { constructor: { value: r, writable: !0, configurable: !0 } }), e && xn(r, e);
}
function Va(r, e) {
  return e != null && typeof Symbol < "u" && e[Symbol.hasInstance] ? !!e[Symbol.hasInstance](r) : r instanceof e;
}
function Ha(r, e) {
  return e && (Fn(e) === "object" || typeof e == "function") ? e : $(r);
}
function xn(r, e) {
  return xn = Object.setPrototypeOf || function(n, t) {
    return n.__proto__ = t, n;
  }, xn(r, e);
}
function Fn(r) {
  "@swc/helpers - typeof";
  return r && typeof Symbol < "u" && r.constructor === Symbol ? "symbol" : typeof r;
}
function Ga() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function Un(r) {
  var e = Ga();
  return function() {
    var t = en(r), i;
    if (e) {
      var c = en(this).constructor;
      i = Reflect.construct(t, arguments, c);
    } else
      i = t.apply(this, arguments);
    return Ha(this, i);
  };
}
function be(r, e) {
  var n, t, i, c, o = { label: 0, sent: function() {
    if (i[0] & 1)
      throw i[1];
    return i[1];
  }, trys: [], ops: [] };
  return c = { next: d(0), throw: d(1), return: d(2) }, typeof Symbol == "function" && (c[Symbol.iterator] = function() {
    return this;
  }), c;
  function d(s) {
    return function(l) {
      return u([s, l]);
    };
  }
  function u(s) {
    if (n)
      throw new TypeError("Generator is already executing.");
    for (; o; )
      try {
        if (n = 1, t && (i = s[0] & 2 ? t.return : s[0] ? t.throw || ((i = t.return) && i.call(t), 0) : t.next) && !(i = i.call(t, s[1])).done)
          return i;
        switch (t = 0, i && (s = [s[0] & 2, i.value]), s[0]) {
          case 0:
          case 1:
            i = s;
            break;
          case 4:
            return o.label++, { value: s[1], done: !1 };
          case 5:
            o.label++, t = s[1], s = [0];
            continue;
          case 7:
            s = o.ops.pop(), o.trys.pop();
            continue;
          default:
            if (i = o.trys, !(i = i.length > 0 && i[i.length - 1]) && (s[0] === 6 || s[0] === 2)) {
              o = 0;
              continue;
            }
            if (s[0] === 3 && (!i || s[1] > i[0] && s[1] < i[3])) {
              o.label = s[1];
              break;
            }
            if (s[0] === 6 && o.label < i[1]) {
              o.label = i[1], i = s;
              break;
            }
            if (i && o.label < i[2]) {
              o.label = i[2], o.ops.push(s);
              break;
            }
            i[2] && o.ops.pop(), o.trys.pop();
            continue;
        }
        s = e.call(r, o);
      } catch (l) {
        s = [6, l], t = 0;
      } finally {
        n = i = 0;
      }
    if (s[0] & 5)
      throw s[1];
    return { value: s[0] ? s[1] : void 0, done: !0 };
  }
}
var Wa = Object.defineProperty, Qa = function(r, e, n) {
  return e in r ? Wa(r, e, { enumerable: !0, configurable: !0, writable: !0, value: n }) : r[e] = n;
}, L = function(r, e, n) {
  return Qa(r, (typeof e > "u" ? "undefined" : Fn(e)) != "symbol" ? e + "" : e, n), n;
}, fn = "connect-session", Ne = "connect-domains", Ja = "wss://nbstream.binance.com/wallet-connector", Za = ["https://rpc.ankr.com/bsc", "https://binance.nodereal.io", "https://bscrpc.com", "https://bsc-dataseed2.ninicoin.io"], qa = function(r) {
  zn(n, r);
  var e = Un(n);
  function n() {
    $n(this, n);
    var t;
    return t = e.call.apply(e, [this].concat(Array.prototype.slice.call(arguments))), L($(t), "pending", !1), L($(t), "callbacks", /* @__PURE__ */ new Map()), L($(t), "clientMeta"), L($(t), "relay"), L($(t), "_key", null), L($(t), "_clientId", ""), L($(t), "_peerId", ""), L($(t), "_peerMeta", null), L($(t), "_handshakeId", 0), L($(t), "_handshakeTopic", ""), L($(t), "_connected", !1), L($(t), "_accounts", []), L($(t), "_chainId", "0x0"), t;
  }
  return Ln(n, [{ key: "key", get: function() {
    return this._key ? _i(this._key, !0) : "";
  }, set: function(t) {
    if (t) {
      var i = Si(t);
      this._key = i;
    }
  } }, { key: "clientId", get: function() {
    var i = this._clientId;
    return i || (i = this._clientId = Mr()), this._clientId;
  }, set: function(t) {
    t && (this._clientId = t);
  } }, { key: "peerId", get: function() {
    return this._peerId;
  }, set: function(t) {
    t && (this._peerId = t);
  } }, { key: "peerMeta", get: function() {
    return this._peerMeta;
  }, set: function(t) {
    this._peerMeta = t;
  } }, { key: "handshakeTopic", get: function() {
    return this._handshakeTopic;
  }, set: function(t) {
    t && (this._handshakeTopic = t);
  } }, { key: "handshakeId", get: function() {
    return this._handshakeId;
  }, set: function(t) {
    t && (this._handshakeId = t);
  } }, { key: "uri", get: function() {
    return "wc:".concat(this.handshakeTopic, "@1?bridge=").concat(this.relay, "&key=").concat(this.key, "&scene=bid");
  } }, { key: "chainId", get: function() {
    return this._chainId;
  }, set: function(t) {
    this._chainId = t;
  } }, { key: "accounts", get: function() {
    return this._accounts;
  }, set: function(t) {
    this._accounts = t;
  } }, { key: "connected", get: function() {
    return this._connected;
  }, set: function(t) {
  } }, { key: "session", get: function() {
    return { connected: this.connected, accounts: this.accounts, chainId: this.chainId, relay: this.relay, key: this.key, clientId: this.clientId, clientMeta: this.clientMeta, peerId: this.peerId, peerMeta: this.peerMeta, handshakeId: this.handshakeId, handshakeTopic: this.handshakeTopic };
  }, set: function(t) {
    t && (this._connected = t.connected, this.accounts = t.accounts, this.chainId = t.chainId, this.relay = t.relay, this.key = t.key, this.clientId = t.clientId, this.clientMeta = t.clientMeta, this.peerId = t.peerId, this.peerMeta = t.peerMeta, this.handshakeId = t.handshakeId, this.handshakeTopic = t.handshakeTopic);
  } }]), n;
}(Nn), Ya = function(r) {
  zn(n, r);
  var e = Un(n);
  function n() {
    return $n(this, n), e.apply(this, arguments);
  }
  return Ln(n, [{ key: "getStorageSession", value: function() {
    try {
      return Rn(fn);
    } catch {
    }
    return null;
  } }, { key: "setStorageSession", value: function() {
    Tn(fn, this.session);
  } }, { key: "removeStorageSession", value: function() {
    Nr(fn);
  } }, { key: "manageStorageSession", value: function() {
    this._connected ? this.setStorageSession() : this.removeStorageSession();
  } }]), n;
}(qa);
function Ka() {
  return Cn.apply(this, arguments);
}
function Cn() {
  return Cn = ge(function() {
    var r, e;
    return be(this, function(n) {
      switch (n.label) {
        case 0:
          return [4, Promise.race(Za.map(function(t) {
            return Ti.request({ url: t, method: "POST", data: { jsonrpc: "2.0", id: Date.now(), method: "eth_call", params: [{ to: "0x76054B318785b588A3164B2A6eA5476F7cBA51e0", data: "0x97b5f450" }, "latest"] } });
          }))];
        case 1:
          return r = n.sent(), e = new Ua(["function apiDomains() view returns (string)"]), [2, Ri(e.decodeFunctionResult("apiDomains", r.data.result)[0]).split(",")];
      }
    });
  }), Cn.apply(this, arguments);
}
function Xa(r) {
  return r.filter(function(e) {
    return e.ttl > 0;
  }).sort(function(e, n) {
    return e.ttl - n.ttl;
  }).map(function(e) {
    return e.url;
  });
}
function ec() {
  return An.apply(this, arguments);
}
function An() {
  return An = ge(function() {
    var r, e;
    return be(this, function(n) {
      switch (n.label) {
        case 0:
          return [4, Ka()];
        case 1:
          return r = n.sent(), [4, Promise.all(r.map(function(t) {
            var i = t.split(".").slice(1).join(".");
            return Qs("wss://nbstream.".concat(i, "/wallet-connector"));
          }))];
        case 2:
          return e = n.sent(), [2, Xa(e)];
      }
    });
  }), An.apply(this, arguments);
}
var _n = Promise.resolve([]);
if (!Mn()) {
  var hn = Rn(Ne);
  _n = Promise.resolve(hn), (!hn || hn.length === 0) && (_n = ec().then(function(r) {
    return console.log("🚀 ~ file: relay.ts:63 ~ .then ~ domains:", r), Tn(Ne, r), r;
  }).catch(function() {
    return [];
  }));
}
function tc() {
  return Sn.apply(this, arguments);
}
function Sn() {
  return Sn = ge(function() {
    var r;
    return be(this, function(e) {
      switch (e.label) {
        case 0:
          return [4, _n];
        case 1:
          return r = e.sent(), [2, (r.length === 0 && r.push(Ja), r)];
      }
    });
  }), Sn.apply(this, arguments);
}
function nc(r) {
  var e = Rn(Ne);
  if (e) {
    var n = e.filter(function(t) {
      return t !== r;
    });
    Tn(Ne, n);
  }
}
function br() {
  Nr(Ne);
}
function rc(r) {
  return r.code === -32050 || r.code === -32e3 || r.code === 1e3 ? new F(ae.REJECT_ERR.code, ae.REJECT_ERR.message) : r.code === -32603 ? new F(pe.INTERNAL_ERR.code, pe.INTERNAL_ERR.message) : r.code === -32600 || r.code === -32602 ? new F(ae.INVALID_PARAM.code, ae.INVALID_PARAM.message) : r;
}
function ic(r) {
  var e = r.indexOf("?");
  return e > -1 ? r.slice(0, e) : r;
}
var oc = function(r) {
  zn(n, r);
  var e = Un(n);
  function n() {
    $n(this, n);
    var t;
    t = e.call(this), L($(t), "transport"), L($(t), "lng"), t.clientMeta = Ii();
    var i = t.getStorageSession();
    return i && (t.session = i), t.handshakeId && t.subscribeToSessionResponse(t.handshakeId), t.initTransport(), t.subscribeInternalEvent(), t;
  }
  return Ln(n, [{ key: "request", value: function(t) {
    var i = this;
    return ge(function() {
      return be(this, function(c) {
        if (!i.connected)
          throw new F(H.PROVIDER_NOT_READY.code, H.PROVIDER_NOT_READY.message);
        if (Rr.indexOf(t.method) < 0)
          throw new F(ae.METHOD_NOT_SUPPORT.code, ae.METHOD_NOT_SUPPORT.message);
        switch (t.method) {
          case "eth_requestAccounts":
            return [2, i.accounts];
          case "eth_accounts":
            return [2, i.accounts];
          case "eth_chainId":
            return [2, Zn(i.chainId)];
          case "eth_signTransaction":
          case "eth_sendTransaction":
          case "eth_sign":
          case "personal_sign":
          case "eth_signTypedData":
          case "eth_signTypedData_v1":
          case "eth_signTypedData_v2":
          case "eth_signTypedData_v3":
          case "eth_signTypedData_v4":
          case "wallet_switchEthereumChain":
          case "wallet_watchAsset":
            return [2, new Promise(function(o, d) {
              t.id || (t.id = un()), i.callbacks.set("response-".concat(t.id), function(u, s) {
                u ? d(rc(u)) : s ? o(s.result) : d(new F(ae.MISSING_RESPONSE.code, ae.MISSING_RESPONSE.message));
              }), i.sendRequest(t), i.events.emit("call_request_sent");
            })];
        }
        return [2];
      });
    })();
  } }, { key: "killSession", value: function() {
    if (this.connected) {
      var i = { approved: !1, chainId: null, networkId: null, accounts: null }, c = { id: un(), method: "wc_sessionUpdate", params: [i] };
      this.sendRequest(c), this.handleSessionDisconnect(qt.DisconnectAtClient);
    }
  } }, { key: "connect", value: function() {
    var i = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, c = i.chainId, o = i.lng, d = i.showQrCodeModal, u = this;
    return ge(function() {
      return be(this, function(s) {
        return [2, (u.lng = o, u.connected ? { chainId: u.chainId, accounts: u.accounts } : new Promise(function(l, f) {
          u.on("modal_closed", function(h) {
            f(h);
          }), u.on("session_error", function(h) {
            f(h);
          }), u.on("connect", function(h) {
            l(h);
          }), u.createSession({ chainId: c, showQrCodeModal: d });
        }))];
      });
    })();
  } }, { key: "createSession", value: function(t) {
    var i = t.chainId, c = t.showQrCodeModal;
    try {
      if (this.connected)
        throw new F(H.CONNECTED.code, H.CONNECTED.message);
      if (this.pending || this._handshakeTopic)
        throw new F(H.CONNECTING.code, H.CONNECTING.message);
      this.pending = !0, this._key = Oi(), this.handshakeId = un(), this.handshakeTopic = Mr();
      var o = { id: this.handshakeId, method: "wc_sessionRequest", params: [{ peerId: this.clientId, peerMeta: this.clientMeta, chainId: i ? Number(i) : null }] };
      this.sendRequest(o, this.handshakeTopic), this.subscribeToSessionResponse(this.handshakeId), this.events.emit("display_uri", { showQrCodeModal: c });
    } catch (l) {
      this.pending = !1;
      var d = "response-".concat(this.handshakeId);
      this.callbacks.get(d) && this.callbacks.delete(d);
      var u = l.message, s = Va(l, F) ? l : new F(pe.INTERNAL_ERR.code, "".concat(pe.INTERNAL_ERR.message, ": ").concat(u));
      throw this.handleRejectSessionConnection(s), se.error("[binance-w3w] create connection failed: ".concat(u)), s;
    }
  } }, { key: "initTransport", value: function() {
    var i = this;
    return ge(function() {
      var c, o, d, u;
      return be(this, function(s) {
        switch (s.label) {
          case 0:
            i.transport = new Ws({ version: 1, subscriptions: [i.clientId] }), i.transport.on("message", function(l) {
              return i.setIncomingMessages(l);
            }), i.transport.on("open", function(l) {
              i.events.emit("transport_open", l);
            }), i.transport.on("close", function() {
              i.events.emit("transport_close");
            }), i.transport.on("error", function(l, f) {
              i.events.emit("transport_error", l, f);
            }), s.label = 1;
          case 1:
            return s.trys.push([1, 5, , 6]), i.session.relay ? (i.transport.open([i.session.relay]), [3, 4]) : [3, 2];
          case 2:
            return [4, tc()];
          case 3:
            c = s.sent(), i.transport.open(c), s.label = 4;
          case 4:
            return [3, 6];
          case 5:
            throw o = s.sent(), br(), d = o.message, u = new F(pe.INTERNAL_ERR.code, "".concat(pe.INTERNAL_ERR.message, ": ").concat(d)), i.handleRejectSessionConnection(u), u;
          case 6:
            return [2];
        }
      });
    })();
  } }, { key: "setIncomingMessages", value: function(t) {
    if ([this.clientId, this.handshakeTopic].includes(t.topic)) {
      var i;
      try {
        i = JSON.parse(t.payload);
      } catch {
        return;
      }
      var c = this.decrypt(i);
      if (c) {
        if ("method" in c && c.method) {
          this.events.emit(c.method, null, c);
          return;
        }
        var o = c.id, d = "response-".concat(o), u = this.callbacks.get(d);
        if (u) {
          if ("error" in c && c.error) {
            var s = new F(c.error.code, c.error.message);
            u(s, null);
          } else
            "result" in c && c.result && u(null, c);
          this.callbacks.delete(d);
        } else
          se.error("[binance-w3w] callback id: ".concat(o, " not found"));
      }
    }
  } }, { key: "encrypt", value: function(t) {
    var i = this._key;
    return i ? Mi(t, i) : null;
  } }, { key: "decrypt", value: function(t) {
    var i = this._key;
    return i ? Ni(t, i) : null;
  } }, { key: "sendRequest", value: function(t, i) {
    var c = pn(t.method, t.params, t.id), o = this.encrypt(c), d = i || this.peerId, u = JSON.stringify(o);
    this.transport.send(u, d, !0);
  } }, { key: "subscribeInternalEvent", value: function() {
    var i = this;
    this.on("display_uri", function(c) {
      var o = c.showQrCodeModal;
      o !== !1 && (re.open({ cb: function() {
        i.events.emit("modal_closed", new F(H.CLOSE_MODAL.code, H.CLOSE_MODAL.message));
      }, lng: i.lng }), i.transport.connected ? (i.events.emit("uri_ready", i.uri), re.ready(i.uri)) : i.transport.retryFailed && re.fail());
    }), this.on("transport_open", function(c) {
      i.relay = c, i.events.emit("uri_ready", i.uri), re.ready(i.uri);
    }), this.on("transport_error", function(c, o) {
      o ? nc(ic(o)) : (br(), re.fail());
    }), this.on("modal_closed", function() {
      var c = "response-".concat(i.handshakeId);
      i.callbacks.get(c) && i.callbacks.delete(c), i.clearConnectionStatus();
    }), this.on("connect", function() {
      i.pending = !1, re.close();
    }), this.on("call_request_sent", function() {
      Sr();
    }), this.on("wc_sessionUpdate", function(c, o) {
      if (c) {
        i.handleSessionResponse();
        return;
      }
      o.params && Array.isArray(o.params) ? i.handleSessionResponse(o.params[0]) : o.error && i.handleSessionResponse();
    });
  } }, { key: "subscribeToSessionResponse", value: function(t) {
    var i = this;
    this.callbacks.set("response-".concat(t), function(c, o) {
      if (c) {
        i.handleSessionResponse();
        return;
      }
      o && (o.result ? i.handleSessionResponse(o.result) : (o.error && o.error.message, i.handleSessionResponse()));
    });
  } }, { key: "handleSessionResponse", value: function(t) {
    t ? t.approved ? (this._connected ? (t.chainId && this.setChainId(t.chainId), t.accounts && this.setAddress(t.accounts)) : (this._connected = !0, t.chainId && this.setChainId(t.chainId), t.accounts && this.setAddress(t.accounts), t.peerId && !this.peerId && (this.peerId = t.peerId), t.peerMeta && !this.peerMeta && (this.peerMeta = t.peerMeta), this.events.emit("connect", { chainId: this.chainId, accounts: this.accounts })), this.manageStorageSession()) : this.connected ? this.handleSessionDisconnect(qt.DisconnectAtWallet) : this.handleRejectSessionConnection(new F(H.REJECT_SESSION.code, H.REJECT_SESSION.message)) : this.handleRejectSessionConnection(new F(H.REJECT_SESSION.code, H.REJECT_SESSION.message));
  } }, { key: "handleRejectSessionConnection", value: function(t) {
    re.close(), this.clearConnectionStatus(), this.events.emit("session_error", t);
  } }, { key: "handleSessionDisconnect", value: function(t) {
    this._connected || re.close(), this.events.emit("disconnect", t), this.clearConnectionStatus();
  } }, { key: "clearConnectionStatus", value: function() {
    this._connected && (this._connected = !1), this._handshakeId && (this._handshakeId = 0), this._handshakeTopic && (this._handshakeTopic = ""), this._peerId && (this._peerId = ""), this._clientId && (this._clientId = ""), this.pending && (this.pending = !1), this.callbacks.clear(), this._peerMeta = null, this._accounts = [], this._chainId = "0x0", this.offConnectEvents(), this.removeStorageSession(), this.transport.close();
  } }, { key: "offConnectEvents", value: function() {
    this.removeListener("connect");
  } }, { key: "setChainId", value: function(t) {
    var i = Zn(t);
    if (i === "0x0") {
      this.chainId = i;
      return;
    }
    Fn(this.chainId) < "u" && this.chainId !== i && this.events.emit("chainChanged", i), this.chainId = i;
  } }, { key: "setAddress", value: function() {
    var i = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], c = i.filter(function(o) {
      return typeof o == "string";
    }).map(function(o) {
      return o.toLowerCase();
    }).filter(Boolean);
    JSON.stringify(this.accounts) !== JSON.stringify(c) && this.events.emit("accountsChanged", c), this.accounts = c;
  } }]), n;
}(Ya);
function In(r) {
  if (r === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return r;
}
function wr(r, e, n, t, i, c, o) {
  try {
    var d = r[c](o), u = d.value;
  } catch (s) {
    n(s);
    return;
  }
  d.done ? e(u) : Promise.resolve(u).then(t, i);
}
function kr(r) {
  return function() {
    var e = this, n = arguments;
    return new Promise(function(t, i) {
      var c = r.apply(e, n);
      function o(u) {
        wr(c, t, i, o, d, "next", u);
      }
      function d(u) {
        wr(c, t, i, o, d, "throw", u);
      }
      o(void 0);
    });
  };
}
function sc(r, e) {
  if (!(r instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function vr(r, e) {
  for (var n = 0; n < e.length; n++) {
    var t = e[n];
    t.enumerable = t.enumerable || !1, t.configurable = !0, "value" in t && (t.writable = !0), Object.defineProperty(r, t.key, t);
  }
}
function ac(r, e, n) {
  return e && vr(r.prototype, e), n && vr(r, n), r;
}
function tn(r) {
  return tn = Object.setPrototypeOf ? Object.getPrototypeOf : function(e) {
    return e.__proto__ || Object.getPrototypeOf(e);
  }, tn(r);
}
function cc(r, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function");
  r.prototype = Object.create(e && e.prototype, { constructor: { value: r, writable: !0, configurable: !0 } }), e && On(r, e);
}
function uc(r, e) {
  return e && (di(e) === "object" || typeof e == "function") ? e : In(r);
}
function On(r, e) {
  return On = Object.setPrototypeOf || function(n, t) {
    return n.__proto__ = t, n;
  }, On(r, e);
}
function di(r) {
  "@swc/helpers - typeof";
  return r && typeof Symbol < "u" && r.constructor === Symbol ? "symbol" : typeof r;
}
function lc() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function dc(r) {
  var e = lc();
  return function() {
    var t = tn(r), i;
    if (e) {
      var c = tn(this).constructor;
      i = Reflect.construct(t, arguments, c);
    } else
      i = t.apply(this, arguments);
    return uc(this, i);
  };
}
function Er(r, e) {
  var n, t, i, c, o = { label: 0, sent: function() {
    if (i[0] & 1)
      throw i[1];
    return i[1];
  }, trys: [], ops: [] };
  return c = { next: d(0), throw: d(1), return: d(2) }, typeof Symbol == "function" && (c[Symbol.iterator] = function() {
    return this;
  }), c;
  function d(s) {
    return function(l) {
      return u([s, l]);
    };
  }
  function u(s) {
    if (n)
      throw new TypeError("Generator is already executing.");
    for (; o; )
      try {
        if (n = 1, t && (i = s[0] & 2 ? t.return : s[0] ? t.throw || ((i = t.return) && i.call(t), 0) : t.next) && !(i = i.call(t, s[1])).done)
          return i;
        switch (t = 0, i && (s = [s[0] & 2, i.value]), s[0]) {
          case 0:
          case 1:
            i = s;
            break;
          case 4:
            return o.label++, { value: s[1], done: !1 };
          case 5:
            o.label++, t = s[1], s = [0];
            continue;
          case 7:
            s = o.ops.pop(), o.trys.pop();
            continue;
          default:
            if (i = o.trys, !(i = i.length > 0 && i[i.length - 1]) && (s[0] === 6 || s[0] === 2)) {
              o = 0;
              continue;
            }
            if (s[0] === 3 && (!i || s[1] > i[0] && s[1] < i[3])) {
              o.label = s[1];
              break;
            }
            if (s[0] === 6 && o.label < i[1]) {
              o.label = i[1], i = s;
              break;
            }
            if (i && o.label < i[2]) {
              o.label = i[2], o.ops.push(s);
              break;
            }
            i[2] && o.ops.pop(), o.trys.pop();
            continue;
        }
        s = e.call(r, o);
      } catch (l) {
        s = [6, l], t = 0;
      } finally {
        n = i = 0;
      }
    if (s[0] & 5)
      throw s[1];
    return { value: s[0] ? s[1] : void 0, done: !0 };
  }
}
var fc = Object.defineProperty, hc = function(r, e, n) {
  return e in r ? fc(r, e, { enumerable: !0, configurable: !0, writable: !0, value: n }) : r[e] = n;
}, xr = function(r, e, n) {
  return hc(r, (typeof e > "u" ? "undefined" : di(e)) != "symbol" ? e + "" : e, n), n;
}, pc = function(r) {
  cc(n, r);
  var e = dc(n);
  function n() {
    sc(this, n);
    var t;
    return t = e.call(this), xr(In(t), "accounts", []), xr(In(t), "coreConnection"), t.register(), t;
  }
  return ac(n, [{ key: "chainId", get: function() {
    return this.coreConnection ? this.coreConnection.chainId : "0x0";
  } }, { key: "connected", get: function() {
    return this.coreConnection ? this.coreConnection.connected : !1;
  } }, { key: "connecting", get: function() {
    return this.coreConnection ? this.coreConnection.pending : !1;
  } }, { key: "open", value: function(t) {
    var i = t.requestChainId, c = t.lng, o = t.showQrCodeModal, d = this;
    return kr(function() {
      var u, s;
      return Er(this, function(l) {
        switch (l.label) {
          case 0:
            return d.register(), d.coreConnection.connected ? [2] : [4, d.coreConnection.connect({ chainId: i, lng: c, showQrCodeModal: o })];
          case 1:
            return u = l.sent(), s = u.accounts, d.accounts = s, [2];
        }
      });
    })();
  } }, { key: "request", value: function(t) {
    var i = this;
    return kr(function() {
      var c;
      return Er(this, function(o) {
        switch (o.label) {
          case 0:
            return c = i.connected, c ? [3, 2] : [4, i.open({})];
          case 1:
            c = o.sent(), o.label = 2;
          case 2:
            return [2, i.coreConnection.request(t)];
        }
      });
    })();
  } }, { key: "disconnect", value: function() {
    this.connected && (this.coreConnection.killSession(), this.onClose(qt.DisconnectAtClient));
  } }, { key: "register", value: function() {
    if (this.coreConnection)
      return this.coreConnection;
    this.coreConnection = new oc(), this.accounts = this.coreConnection.accounts, this.subscribeEvents();
  } }, { key: "subscribeEvents", value: function() {
    var i = this;
    this.coreConnection.on("chainChanged", function(c) {
      i.events.emit("chainChanged", c);
    }), this.coreConnection.on("accountsChanged", function(c) {
      i.accounts = c, i.events.emit("accountsChanged", c);
    }), this.coreConnection.on("uri_ready", function(c) {
      i.events.emit("uri_ready", c);
    }), this.coreConnection.on("disconnect", function(c) {
      i.onClose(c);
    });
  } }, { key: "onClose", value: function(t) {
    this.coreConnection = null, this.events.emit("disconnect", t);
  } }]), n;
}(Nn);
function Cr(r, e, n, t, i, c, o) {
  try {
    var d = r[c](o), u = d.value;
  } catch (s) {
    n(s);
    return;
  }
  d.done ? e(u) : Promise.resolve(u).then(t, i);
}
function xe(r) {
  return function() {
    var e = this, n = arguments;
    return new Promise(function(t, i) {
      var c = r.apply(e, n);
      function o(u) {
        Cr(c, t, i, o, d, "next", u);
      }
      function d(u) {
        Cr(c, t, i, o, d, "throw", u);
      }
      o(void 0);
    });
  };
}
function mc(r, e) {
  if (!(r instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function Ar(r, e) {
  for (var n = 0; n < e.length; n++) {
    var t = e[n];
    t.enumerable = t.enumerable || !1, t.configurable = !0, "value" in t && (t.writable = !0), Object.defineProperty(r, t.key, t);
  }
}
function yc(r, e, n) {
  return e && Ar(r.prototype, e), n && Ar(r, n), r;
}
function nn(r) {
  "@swc/helpers - typeof";
  return r && typeof Symbol < "u" && r.constructor === Symbol ? "symbol" : typeof r;
}
function Ce(r, e) {
  var n, t, i, c, o = { label: 0, sent: function() {
    if (i[0] & 1)
      throw i[1];
    return i[1];
  }, trys: [], ops: [] };
  return c = { next: d(0), throw: d(1), return: d(2) }, typeof Symbol == "function" && (c[Symbol.iterator] = function() {
    return this;
  }), c;
  function d(s) {
    return function(l) {
      return u([s, l]);
    };
  }
  function u(s) {
    if (n)
      throw new TypeError("Generator is already executing.");
    for (; o; )
      try {
        if (n = 1, t && (i = s[0] & 2 ? t.return : s[0] ? t.throw || ((i = t.return) && i.call(t), 0) : t.next) && !(i = i.call(t, s[1])).done)
          return i;
        switch (t = 0, i && (s = [s[0] & 2, i.value]), s[0]) {
          case 0:
          case 1:
            i = s;
            break;
          case 4:
            return o.label++, { value: s[1], done: !1 };
          case 5:
            o.label++, t = s[1], s = [0];
            continue;
          case 7:
            s = o.ops.pop(), o.trys.pop();
            continue;
          default:
            if (i = o.trys, !(i = i.length > 0 && i[i.length - 1]) && (s[0] === 6 || s[0] === 2)) {
              o = 0;
              continue;
            }
            if (s[0] === 3 && (!i || s[1] > i[0] && s[1] < i[3])) {
              o.label = s[1];
              break;
            }
            if (s[0] === 6 && o.label < i[1]) {
              o.label = i[1], i = s;
              break;
            }
            if (i && o.label < i[2]) {
              o.label = i[2], o.ops.push(s);
              break;
            }
            i[2] && o.ops.pop(), o.trys.pop();
            continue;
        }
        s = e.call(r, o);
      } catch (l) {
        s = [6, l], t = 0;
      } finally {
        n = i = 0;
      }
    if (s[0] & 5)
      throw s[1];
    return { value: s[0] ? s[1] : void 0, done: !0 };
  }
}
var gc = Object.defineProperty, bc = function(r, e, n) {
  return e in r ? gc(r, e, { enumerable: !0, configurable: !0, writable: !0, value: n }) : r[e] = n;
}, ce = function(r, e, n) {
  return bc(r, (typeof e > "u" ? "undefined" : nn(e)) != "symbol" ? e + "" : e, n), n;
}, fi = function() {
  function r(e) {
    mc(this, r), ce(this, "events", new _r()), ce(this, "signClient"), ce(this, "rpc"), ce(this, "httpClient"), ce(this, "optsChainId"), ce(this, "lng"), ce(this, "showQrCodeModal"), this.rpc = { infuraId: e == null ? void 0 : e.infuraId, custom: e == null ? void 0 : e.rpc }, this.lng = (e == null ? void 0 : e.lng) || "en", this.showQrCodeModal = e == null ? void 0 : e.showQrCodeModal, this.signClient = new pc(), this.optsChainId = Number(this.signClient.coreConnection.chainId) || (e == null ? void 0 : e.chainId) || 56, this.registerEventListeners(), this.httpClient = this.setHttpProvider(this.optsChainId);
  }
  return yc(r, [{ key: "connected", get: function() {
    return this.signClient.connected;
  } }, { key: "connector", get: function() {
    return this.signClient;
  } }, { key: "accounts", get: function() {
    return this.signClient.accounts;
  } }, { key: "chainId", get: function() {
    return se.debug("provider get chainId", this.signClient.chainId), this.signClient.chainId;
  } }, { key: "rpcUrl", get: function() {
    return this.httpClient.url || "";
  } }, { key: "request", value: function(e) {
    var n = this;
    return xe(function() {
      var t, i, c;
      return Ce(this, function(o) {
        switch (o.label) {
          case 0:
            switch (t = (se.debug("ethereum-provider request", e), e.method), t) {
              case "eth_requestAccounts":
                return [3, 1];
              case "eth_chainId":
                return [3, 3];
              case "eth_accounts":
                return [3, 4];
              case "wallet_switchEthereumChain":
                return [3, 5];
            }
            return [3, 6];
          case 1:
            return [4, n.connect()];
          case 2:
            return [2, (o.sent(), n.accounts)];
          case 3:
            return [2, n.chainId];
          case 4:
            return [2, n.accounts];
          case 5:
            return [2, n.switchChain(e)];
          case 6:
            return [3, 7];
          case 7:
            if (i = pn(e.method, e.params || []), Rr.includes(e.method))
              return [2, n.signClient.request(i)];
            if (nn(n.httpClient) > "u")
              throw new Error("Cannot request JSON-RPC method (".concat(e.method, ") without provided rpc url"));
            return [4, n.httpClient.request(i)];
          case 8:
            if (c = o.sent(), Di(c))
              return [2, c.result];
            throw new Error(c.error.message);
        }
      });
    })();
  } }, { key: "signMessage", value: function(e) {
    var n = this;
    return xe(function() {
      var t;
      return Ce(this, function(i) {
        switch (i.label) {
          case 0:
            return se.debug("signMessage", e), t = n.accounts.length, t ? [3, 2] : [4, n.enable()];
          case 1:
            t = i.sent(), i.label = 2;
          case 2:
            return [4, n.request({ method: "personal_sign", params: [$i(e), n.accounts[0]] })];
          case 3:
            return [2, i.sent()];
        }
      });
    })();
  } }, { key: "sendAsync", value: function(e, n) {
    this.request(e).then(function(t) {
      return n(null, t);
    }).catch(function(t) {
      return n(t, void 0);
    });
  } }, { key: "setLng", value: function(e) {
    this.lng = e;
  } }, { key: "enable", value: function(e) {
    var n = this;
    return xe(function() {
      return Ce(this, function(t) {
        switch (t.label) {
          case 0:
            return [4, n.connect(e)];
          case 1:
            return [2, (t.sent(), n.accounts)];
        }
      });
    })();
  } }, { key: "switchChain", value: function(e) {
    var n = this;
    return xe(function() {
      var t;
      return Ce(this, function(i) {
        switch (i.label) {
          case 0:
            return t = pn(e.method, e.params || []), [4, Promise.race([n.signClient.request(t), new Promise(function(c) {
              return n.on("chainChanged", function(o) {
                o === e.params[0].chainId && c(o);
              });
            })])];
          case 1:
            return [2, i.sent()];
        }
      });
    })();
  } }, { key: "connect", value: function(e) {
    var n = this;
    return xe(function() {
      var t;
      return Ce(this, function(i) {
        switch (i.label) {
          case 0:
            return n.connected ? (se.info("already connected"), [3, 3]) : [3, 1];
          case 1:
            return [4, n.signClient.open({ requestChainId: (t = e == null ? void 0 : e.toString()) !== null && t !== void 0 ? t : n.optsChainId.toString(), lng: n.lng, showQrCodeModal: n.showQrCodeModal })];
          case 2:
            i.sent(), i.label = 3;
          case 3:
            return [2];
        }
      });
    })();
  } }, { key: "disconnect", value: function() {
    this.connected && this.signClient.disconnect();
  } }, { key: "on", value: function(e, n) {
    this.events.on(e, n);
  } }, { key: "once", value: function(e, n) {
    this.events.once(e, n);
  } }, { key: "removeListener", value: function(e, n) {
    this.events.removeListener(e, n);
  } }, { key: "off", value: function(e, n) {
    this.events.off(e, n);
  } }, { key: "isWalletConnect", get: function() {
    return !0;
  } }, { key: "registerEventListeners", value: function() {
    var n = this;
    this.signClient.on("accountsChanged", function(t) {
      n.events.emit("accountsChanged", t);
    }), this.signClient.on("chainChanged", function(t) {
      n.httpClient = n.setHttpProvider(Bi(t)), n.events.emit("chainChanged", t);
    }), this.signClient.on("disconnect", function() {
      n.events.emit("disconnect");
    }), this.signClient.on("uri_ready", function(t) {
      n.events.emit("uri_ready", t);
    });
  } }, { key: "setHttpProvider", value: function(e) {
    var n = ji(e, this.rpc);
    if (!((typeof n > "u" ? "undefined" : nn(n)) > "u"))
      return new Yi(n);
  } }]), r;
}(), xc = function(r) {
  if (Pi()) {
    var e = (typeof window > "u" ? "undefined" : nn(window)) < "u" ? window.ethereum : void 0;
    if (e)
      return e.setLng = function() {
      }, e.disconnect = function() {
      }, e;
  }
  return new fi(r);
}, Cc = fi;
export {
  Cc as default,
  xc as getProvider
};
